/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as ConsoleRouteImport } from "./routes/_console";
import { Route as HeadsetRouteImport } from "./routes/headset";
import { Route as SignedOutRouteImport } from "./routes/signed-out";
import { Route as ConsoleIndexRouteImport } from "./routes/_console/index";
import { Route as ConsoleSplatRouteImport } from "./routes/_console/$";
import { Route as ConsoleLabelRouteRouteImport } from "./routes/_console/label/route";
import { Route as ConsoleOperationsRouteRouteImport } from "./routes/_console/operations/route";
import { Route as ConsoleProductionRouteRouteImport } from "./routes/_console/production/route";
import { Route as ConsoleProjectsRouteImport } from "./routes/_console/projects";
import { Route as ConsoleSettingsRouteRouteImport } from "./routes/_console/settings/route";
import { Route as ConsoleTeleoperatorsRouteRouteImport } from "./routes/_console/teleoperators/route";
import { Route as ConsoleLabelIndexRouteImport } from "./routes/_console/label/index";
import { Route as ConsoleLabelAdminRouteImport } from "./routes/_console/label/admin";
import { Route as ConsoleLabelPrincipalRouteImport } from "./routes/_console/label/principal";
import { Route as ConsoleLabelQcRouteImport } from "./routes/_console/label/qc";
import { Route as ConsoleOperationsIndexRouteImport } from "./routes/_console/operations/index";
import { Route as ConsoleOperationsReleasesRouteImport } from "./routes/_console/operations/releases";
import { Route as ConsoleProductionIndexRouteImport } from "./routes/_console/production/index";
import { Route as ConsoleProductionActivityRouteImport } from "./routes/_console/production/activity";
import { Route as ConsoleProductionChecksRouteImport } from "./routes/_console/production/checks";
import { Route as ConsoleProductionCollectionsRouteImport } from "./routes/_console/production/collections";
import { Route as ConsoleProductionEpisodesRouteImport } from "./routes/_console/production/episodes";
import { Route as ConsoleProductionOperatorsRouteImport } from "./routes/_console/production/operators";
import { Route as ConsoleProductionPeopleRouteImport } from "./routes/_console/production/people";
import { Route as ConsoleProductionPodsRouteImport } from "./routes/_console/production/pods";
import { Route as ConsoleProductionUploadsRouteImport } from "./routes/_console/production/uploads";
import { Route as ConsoleProjectsIndexRouteImport } from "./routes/_console/projects.index";
import { Route as ConsoleSettingsIndexRouteImport } from "./routes/_console/settings/index";
import { Route as ConsoleSettingsBillingRouteImport } from "./routes/_console/settings/billing";
import { Route as ConsoleSettingsKeysRouteImport } from "./routes/_console/settings/keys";
import { Route as ConsoleSettingsOperatorsRouteImport } from "./routes/_console/settings/operators";
import { Route as ConsoleSettingsOrganizationsRouteImport } from "./routes/_console/settings/organizations";
import { Route as ConsoleSettingsPeopleRouteImport } from "./routes/_console/settings/people";
import { Route as ConsoleSettingsPlatformRouteRouteImport } from "./routes/_console/settings/platform/route";
import { Route as ConsoleSettingsProjectsRouteImport } from "./routes/_console/settings/projects";
import { Route as ConsoleSettingsSessionsRouteImport } from "./routes/_console/settings/sessions";
import { Route as ConsoleSuperviseSplatRouteImport } from "./routes/_console/supervise.$";
import { Route as ConsoleTeleoperatorsIndexRouteImport } from "./routes/_console/teleoperators/index";
import { Route as ConsoleTeleoperatorsPeopleRouteImport } from "./routes/_console/teleoperators/people";
import { Route as ConsoleTeleoperatorsSessionsRouteImport } from "./routes/_console/teleoperators/sessions";
import { Route as ConsoleLabelAnnotateEpisodeIdRouteImport } from "./routes/_console/label/annotate.$episodeId";
import { Route as ConsoleLabelAuditIndexRouteImport } from "./routes/_console/label/audit.index";
import { Route as ConsoleLabelAuditEpisodeIdRouteImport } from "./routes/_console/label/audit.$episodeId";
import { Route as ConsoleLabelQcIndexRouteImport } from "./routes/_console/label/qc.index";
import { Route as ConsoleLabelQcAccuracyRouteImport } from "./routes/_console/label/qc.accuracy";
import { Route as ConsolePOrgProjectRouteImport } from "./routes/_console/p.$org.$project";
import { Route as ConsoleProductionCollectionsCollectionIdRouteImport } from "./routes/_console/production/collections_.$collectionId";
import { Route as ConsoleProductionEpisodesEpisodeIdRouteImport } from "./routes/_console/production/episodes_.$episodeId";
import { Route as ConsoleProductionPodsIndexRouteImport } from "./routes/_console/production/pods.index";
import { Route as ConsoleSettingsOrganizationsIndexRouteImport } from "./routes/_console/settings/organizations.index";
import { Route as ConsoleSettingsOrganizationsOrganizationIdRouteImport } from "./routes/_console/settings/organizations.$organizationId";
import { Route as ConsoleSettingsPlatformIndexRouteImport } from "./routes/_console/settings/platform/index";
import { Route as ConsoleSettingsPlatformActAsRouteImport } from "./routes/_console/settings/platform/act-as";
import { Route as ConsoleSettingsPlatformAudiencesRouteImport } from "./routes/_console/settings/platform/audiences";
import { Route as ConsoleSettingsPlatformNodesRouteImport } from "./routes/_console/settings/platform/nodes";
import { Route as ConsoleSettingsPlatformOrganizationsRouteImport } from "./routes/_console/settings/platform/organizations";
import { Route as ConsoleSettingsPlatformPrincipalsRouteImport } from "./routes/_console/settings/platform/principals";
import { Route as ConsoleSettingsProjectsIndexRouteImport } from "./routes/_console/settings/projects.index";
import { Route as ConsoleSettingsProjectsProjectIdRouteImport } from "./routes/_console/settings/projects.$projectId";
import { Route as ConsoleTeleoperatorsCockpitTicketIdRouteImport } from "./routes/_console/teleoperators/cockpit.$ticketId";
import { Route as ConsolePOrgProjectIndexRouteImport } from "./routes/_console/p.$org.$project.index";
import { Route as ConsolePOrgProjectBuildWorldsRouteRouteImport } from "./routes/_console/p.$org.$project.build-worlds/route";
import { Route as ConsolePOrgProjectDeployRouteRouteImport } from "./routes/_console/p.$org.$project.deploy/route";
import { Route as ConsolePOrgProjectLibraryRouteRouteImport } from "./routes/_console/p.$org.$project.library/route";
import { Route as ConsolePOrgProjectOperationsRouteImport } from "./routes/_console/p.$org.$project.operations";
import { Route as ConsolePOrgProjectOrdersRouteImport } from "./routes/_console/p.$org.$project.orders";
import { Route as ConsolePOrgProjectReportsRouteRouteImport } from "./routes/_console/p.$org.$project.reports/route";
import { Route as ConsolePOrgProjectSettingsRouteImport } from "./routes/_console/p.$org.$project.settings";
import { Route as ConsolePOrgProjectSimulateRouteRouteImport } from "./routes/_console/p.$org.$project.simulate/route";
import { Route as ConsolePOrgProjectSupplyRouteRouteImport } from "./routes/_console/p.$org.$project.supply/route";
import { Route as ConsolePOrgProjectTasksRouteImport } from "./routes/_console/p.$org.$project.tasks";
import { Route as ConsolePOrgProjectTrainingRouteRouteImport } from "./routes/_console/p.$org.$project.training/route";
import { Route as ConsolePOrgProjectWorkAtlasRouteRouteImport } from "./routes/_console/p.$org.$project.work-atlas/route";
import { Route as ConsoleProductionPodsPodIdIndexRouteImport } from "./routes/_console/production/pods.$podId.index";
import { Route as ConsoleProductionPodsPodIdEpisodeIdRouteImport } from "./routes/_console/production/pods_.$podId.$episodeId";
import { Route as ConsoleSettingsOrganizationsOrganizationIdBillingRouteImport } from "./routes/_console/settings/organizations.$organizationId_.billing";
import { Route as ConsolePOrgProjectBuildWorldsIndexRouteImport } from "./routes/_console/p.$org.$project.build-worlds/index";
import { Route as ConsolePOrgProjectBuildWorldsAssetsRouteImport } from "./routes/_console/p.$org.$project.build-worlds/assets";
import { Route as ConsolePOrgProjectBuildWorldsCreateRouteImport } from "./routes/_console/p.$org.$project.build-worlds/create";
import { Route as ConsolePOrgProjectDeployIndexRouteImport } from "./routes/_console/p.$org.$project.deploy/index";
import { Route as ConsolePOrgProjectDeployRobotRouteImport } from "./routes/_console/p.$org.$project.deploy/$robot";
import { Route as ConsolePOrgProjectDeployStationsRouteImport } from "./routes/_console/p.$org.$project.deploy/stations";
import { Route as ConsolePOrgProjectLibraryIndexRouteImport } from "./routes/_console/p.$org.$project.library/index";
import { Route as ConsolePOrgProjectLibraryIssuesRouteImport } from "./routes/_console/p.$org.$project.library/issues";
import { Route as ConsolePOrgProjectLibraryMapRouteImport } from "./routes/_console/p.$org.$project.library/map";
import { Route as ConsolePOrgProjectLibrarySearchRouteImport } from "./routes/_console/p.$org.$project.library/search";
import { Route as ConsolePOrgProjectLibrarySemanticRouteImport } from "./routes/_console/p.$org.$project.library/semantic";
import { Route as ConsolePOrgProjectLoopIndexRouteImport } from "./routes/_console/p.$org.$project.loop.index";
import { Route as ConsolePOrgProjectLoopBoardRouteImport } from "./routes/_console/p.$org.$project.loop.board";
import { Route as ConsolePOrgProjectLoopManagerRouteImport } from "./routes/_console/p.$org.$project.loop.manager";
import { Route as ConsolePOrgProjectLoopTeamRouteImport } from "./routes/_console/p.$org.$project.loop.team";
import { Route as ConsolePOrgProjectOrdersIndexRouteImport } from "./routes/_console/p.$org.$project.orders.index";
import { Route as ConsolePOrgProjectReportsIndexRouteImport } from "./routes/_console/p.$org.$project.reports/index";
import { Route as ConsolePOrgProjectReportsModelRouteImport } from "./routes/_console/p.$org.$project.reports/model";
import { Route as ConsolePOrgProjectReportsNewRouteImport } from "./routes/_console/p.$org.$project.reports/new";
import { Route as ConsolePOrgProjectRobotsIndexRouteImport } from "./routes/_console/p.$org.$project.robots.index";
import { Route as ConsolePOrgProjectRobotsComposeRouteImport } from "./routes/_console/p.$org.$project.robots.compose";
import { Route as ConsolePOrgProjectSimulateIndexRouteImport } from "./routes/_console/p.$org.$project.simulate/index";
import { Route as ConsolePOrgProjectSimulateCreateRouteImport } from "./routes/_console/p.$org.$project.simulate/create";
import { Route as ConsolePOrgProjectSimulateRunsRouteImport } from "./routes/_console/p.$org.$project.simulate/runs";
import { Route as ConsolePOrgProjectSimulateSessionsRouteImport } from "./routes/_console/p.$org.$project.simulate/sessions";
import { Route as ConsolePOrgProjectSupplyIndexRouteImport } from "./routes/_console/p.$org.$project.supply/index";
import { Route as ConsolePOrgProjectSupplyOrdersRouteImport } from "./routes/_console/p.$org.$project.supply/orders";
import { Route as ConsolePOrgProjectSupplyShipmentsRouteImport } from "./routes/_console/p.$org.$project.supply/shipments";
import { Route as ConsolePOrgProjectTasksIndexRouteImport } from "./routes/_console/p.$org.$project.tasks.index";
import { Route as ConsolePOrgProjectTasksTaskIdRouteImport } from "./routes/_console/p.$org.$project.tasks.$taskId";
import { Route as ConsolePOrgProjectTrainingIndexRouteImport } from "./routes/_console/p.$org.$project.training/index";
import { Route as ConsolePOrgProjectTrainingCompareRouteImport } from "./routes/_console/p.$org.$project.training/compare";
import { Route as ConsolePOrgProjectWorkAtlasIndexRouteImport } from "./routes/_console/p.$org.$project.work-atlas/index";
import { Route as ConsolePOrgProjectWorkAtlasHomeRouteImport } from "./routes/_console/p.$org.$project.work-atlas/home";
import { Route as ConsolePOrgProjectWorkAtlasOccupationsRouteImport } from "./routes/_console/p.$org.$project.work-atlas/occupations";
import { Route as ConsolePOrgProjectWorkAtlasOpportunitiesRouteImport } from "./routes/_console/p.$org.$project.work-atlas/opportunities";
import { Route as ConsolePOrgProjectWorkAtlasSkillsRouteImport } from "./routes/_console/p.$org.$project.work-atlas/skills";
import { Route as ConsolePOrgProjectWorkAtlasTasksRouteImport } from "./routes/_console/p.$org.$project.work-atlas/tasks";
import { Route as ConsolePOrgProjectBuildWorldsAssetsWorldIdRouteImport } from "./routes/_console/p.$org.$project.build-worlds/assets.$worldId";
import { Route as ConsolePOrgProjectBuildWorldsDraftsDraftIdRouteImport } from "./routes/_console/p.$org.$project.build-worlds/drafts.$draftId";
import { Route as ConsolePOrgProjectDeployLaddersSplatRouteImport } from "./routes/_console/p.$org.$project.deploy/ladders.$";
import { Route as ConsolePOrgProjectDeployStationsIndexRouteImport } from "./routes/_console/p.$org.$project.deploy/stations.index";
import { Route as ConsolePOrgProjectDeployStationsStationIdRouteImport } from "./routes/_console/p.$org.$project.deploy/stations.$stationId";
import { Route as ConsolePOrgProjectLibraryAgentsAgentIdRouteImport } from "./routes/_console/p.$org.$project.library/agents.$agentId";
import { Route as ConsolePOrgProjectLibraryContractsIdRouteImport } from "./routes/_console/p.$org.$project.library/contracts.$id";
import { Route as ConsolePOrgProjectLibraryItemsNameRouteImport } from "./routes/_console/p.$org.$project.library/items.$name";
import { Route as ConsolePOrgProjectReportsNameIndexRouteImport } from "./routes/_console/p.$org.$project.reports/$name.index";
import { Route as ConsolePOrgProjectReportsNameChangesRouteImport } from "./routes/_console/p.$org.$project.reports/$name.changes";
import { Route as ConsolePOrgProjectReportsNameEditRouteImport } from "./routes/_console/p.$org.$project.reports/$name.edit";
import { Route as ConsolePOrgProjectRobotsBodiesBodyRouteImport } from "./routes/_console/p.$org.$project.robots.bodies.$body";
import { Route as ConsolePOrgProjectSimulateAssetsWorldIdRouteImport } from "./routes/_console/p.$org.$project.simulate/assets.$worldId";
import { Route as ConsolePOrgProjectSimulateDraftsIndexRouteImport } from "./routes/_console/p.$org.$project.simulate/drafts.index";
import { Route as ConsolePOrgProjectSimulateDraftsDraftIdRouteImport } from "./routes/_console/p.$org.$project.simulate/drafts.$draftId";
import { Route as ConsolePOrgProjectTrainingJobsJobIdRouteImport } from "./routes/_console/p.$org.$project.training/jobs.$jobId";
import { Route as ConsolePOrgProjectTrainingResearchIndexRouteImport } from "./routes/_console/p.$org.$project.training/research.index";
import { Route as ConsolePOrgProjectTrainingResearchSessionNameRouteImport } from "./routes/_console/p.$org.$project.training/research.$sessionName";
import { Route as ConsolePOrgProjectTrainingRunsIndexRouteImport } from "./routes/_console/p.$org.$project.training/runs.index";
import { Route as ConsolePOrgProjectTrainingRunsRunIdRouteImport } from "./routes/_console/p.$org.$project.training/runs.$runId";
import { Route as ConsolePOrgProjectDeployRobotSessionsSessionRouteImport } from "./routes/_console/p.$org.$project.deploy/$robot_.sessions.$session";
import { Route as ConsolePOrgProjectLibraryDatasetsNameIndexRouteImport } from "./routes/_console/p.$org.$project.library/datasets.$name.index";
import { Route as ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRouteImport } from "./routes/_console/p.$org.$project.library/episodes.$sessionId.$episodeId";
import { Route as ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125RouteImport } from "./routes/_console/p.$org.$project.loop.agent.$agentId.{-$sessionId}";
import { Route as ConsolePOrgProjectReportsNameVersionsVersionRouteImport } from "./routes/_console/p.$org.$project.reports/$name.versions.$version";
import { Route as ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRouteImport } from "./routes/_console/p.$org.$project.library/datasets.$name.segments.$segmentId";

const ConsoleRoute = ConsoleRouteImport.update({
  id: "/_console",
  getParentRoute: () => rootRouteImport,
} as any);
const HeadsetRoute = HeadsetRouteImport.update({
  id: "/headset",
  path: "/headset",
  getParentRoute: () => rootRouteImport,
} as any);
const SignedOutRoute = SignedOutRouteImport.update({
  id: "/signed-out",
  path: "/signed-out",
  getParentRoute: () => rootRouteImport,
} as any);
const ConsoleIndexRoute = ConsoleIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleSplatRoute = ConsoleSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleLabelRouteRoute = ConsoleLabelRouteRouteImport.update({
  id: "/label",
  path: "/label",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleOperationsRouteRoute = ConsoleOperationsRouteRouteImport.update({
  id: "/operations",
  path: "/operations",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleProductionRouteRoute = ConsoleProductionRouteRouteImport.update({
  id: "/production",
  path: "/production",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleProjectsRoute = ConsoleProjectsRouteImport.update({
  id: "/projects",
  path: "/projects",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleSettingsRouteRoute = ConsoleSettingsRouteRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleTeleoperatorsRouteRoute =
  ConsoleTeleoperatorsRouteRouteImport.update({
    id: "/teleoperators",
    path: "/teleoperators",
    getParentRoute: () => ConsoleRoute,
  } as any);
const ConsoleLabelIndexRoute = ConsoleLabelIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ConsoleLabelRouteRoute,
} as any);
const ConsoleLabelAdminRoute = ConsoleLabelAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => ConsoleLabelRouteRoute,
} as any);
const ConsoleLabelPrincipalRoute = ConsoleLabelPrincipalRouteImport.update({
  id: "/principal",
  path: "/principal",
  getParentRoute: () => ConsoleLabelRouteRoute,
} as any);
const ConsoleLabelQcRoute = ConsoleLabelQcRouteImport.update({
  id: "/qc",
  path: "/qc",
  getParentRoute: () => ConsoleLabelRouteRoute,
} as any);
const ConsoleOperationsIndexRoute = ConsoleOperationsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ConsoleOperationsRouteRoute,
} as any);
const ConsoleOperationsReleasesRoute =
  ConsoleOperationsReleasesRouteImport.update({
    id: "/releases",
    path: "/releases",
    getParentRoute: () => ConsoleOperationsRouteRoute,
  } as any);
const ConsoleProductionIndexRoute = ConsoleProductionIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ConsoleProductionRouteRoute,
} as any);
const ConsoleProductionActivityRoute =
  ConsoleProductionActivityRouteImport.update({
    id: "/activity",
    path: "/activity",
    getParentRoute: () => ConsoleProductionRouteRoute,
  } as any);
const ConsoleProductionChecksRoute = ConsoleProductionChecksRouteImport.update({
  id: "/checks",
  path: "/checks",
  getParentRoute: () => ConsoleProductionRouteRoute,
} as any);
const ConsoleProductionCollectionsRoute =
  ConsoleProductionCollectionsRouteImport.update({
    id: "/collections",
    path: "/collections",
    getParentRoute: () => ConsoleProductionRouteRoute,
  } as any);
const ConsoleProductionEpisodesRoute =
  ConsoleProductionEpisodesRouteImport.update({
    id: "/episodes",
    path: "/episodes",
    getParentRoute: () => ConsoleProductionRouteRoute,
  } as any);
const ConsoleProductionOperatorsRoute =
  ConsoleProductionOperatorsRouteImport.update({
    id: "/operators",
    path: "/operators",
    getParentRoute: () => ConsoleProductionRouteRoute,
  } as any);
const ConsoleProductionPeopleRoute = ConsoleProductionPeopleRouteImport.update({
  id: "/people",
  path: "/people",
  getParentRoute: () => ConsoleProductionRouteRoute,
} as any);
const ConsoleProductionPodsRoute = ConsoleProductionPodsRouteImport.update({
  id: "/pods",
  path: "/pods",
  getParentRoute: () => ConsoleProductionRouteRoute,
} as any);
const ConsoleProductionUploadsRoute =
  ConsoleProductionUploadsRouteImport.update({
    id: "/uploads",
    path: "/uploads",
    getParentRoute: () => ConsoleProductionRouteRoute,
  } as any);
const ConsoleProjectsIndexRoute = ConsoleProjectsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ConsoleProjectsRoute,
} as any);
const ConsoleSettingsIndexRoute = ConsoleSettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ConsoleSettingsRouteRoute,
} as any);
const ConsoleSettingsBillingRoute = ConsoleSettingsBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => ConsoleSettingsRouteRoute,
} as any);
const ConsoleSettingsKeysRoute = ConsoleSettingsKeysRouteImport.update({
  id: "/keys",
  path: "/keys",
  getParentRoute: () => ConsoleSettingsRouteRoute,
} as any);
const ConsoleSettingsOperatorsRoute =
  ConsoleSettingsOperatorsRouteImport.update({
    id: "/operators",
    path: "/operators",
    getParentRoute: () => ConsoleSettingsRouteRoute,
  } as any);
const ConsoleSettingsOrganizationsRoute =
  ConsoleSettingsOrganizationsRouteImport.update({
    id: "/organizations",
    path: "/organizations",
    getParentRoute: () => ConsoleSettingsRouteRoute,
  } as any);
const ConsoleSettingsPeopleRoute = ConsoleSettingsPeopleRouteImport.update({
  id: "/people",
  path: "/people",
  getParentRoute: () => ConsoleSettingsRouteRoute,
} as any);
const ConsoleSettingsPlatformRouteRoute =
  ConsoleSettingsPlatformRouteRouteImport.update({
    id: "/platform",
    path: "/platform",
    getParentRoute: () => ConsoleSettingsRouteRoute,
  } as any);
const ConsoleSettingsProjectsRoute = ConsoleSettingsProjectsRouteImport.update({
  id: "/projects",
  path: "/projects",
  getParentRoute: () => ConsoleSettingsRouteRoute,
} as any);
const ConsoleSettingsSessionsRoute = ConsoleSettingsSessionsRouteImport.update({
  id: "/sessions",
  path: "/sessions",
  getParentRoute: () => ConsoleSettingsRouteRoute,
} as any);
const ConsoleSuperviseSplatRoute = ConsoleSuperviseSplatRouteImport.update({
  id: "/supervise/$",
  path: "/supervise/$",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleTeleoperatorsIndexRoute =
  ConsoleTeleoperatorsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsoleTeleoperatorsRouteRoute,
  } as any);
const ConsoleTeleoperatorsPeopleRoute =
  ConsoleTeleoperatorsPeopleRouteImport.update({
    id: "/people",
    path: "/people",
    getParentRoute: () => ConsoleTeleoperatorsRouteRoute,
  } as any);
const ConsoleTeleoperatorsSessionsRoute =
  ConsoleTeleoperatorsSessionsRouteImport.update({
    id: "/sessions",
    path: "/sessions",
    getParentRoute: () => ConsoleTeleoperatorsRouteRoute,
  } as any);
const ConsoleLabelAnnotateEpisodeIdRoute =
  ConsoleLabelAnnotateEpisodeIdRouteImport.update({
    id: "/annotate/$episodeId",
    path: "/annotate/$episodeId",
    getParentRoute: () => ConsoleLabelRouteRoute,
  } as any);
const ConsoleLabelAuditIndexRoute = ConsoleLabelAuditIndexRouteImport.update({
  id: "/audit/",
  path: "/audit/",
  getParentRoute: () => ConsoleLabelRouteRoute,
} as any);
const ConsoleLabelAuditEpisodeIdRoute =
  ConsoleLabelAuditEpisodeIdRouteImport.update({
    id: "/audit/$episodeId",
    path: "/audit/$episodeId",
    getParentRoute: () => ConsoleLabelRouteRoute,
  } as any);
const ConsoleLabelQcIndexRoute = ConsoleLabelQcIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ConsoleLabelQcRoute,
} as any);
const ConsoleLabelQcAccuracyRoute = ConsoleLabelQcAccuracyRouteImport.update({
  id: "/accuracy",
  path: "/accuracy",
  getParentRoute: () => ConsoleLabelQcRoute,
} as any);
const ConsolePOrgProjectRoute = ConsolePOrgProjectRouteImport.update({
  id: "/p/$org/$project",
  path: "/p/$org/$project",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleProductionCollectionsCollectionIdRoute =
  ConsoleProductionCollectionsCollectionIdRouteImport.update({
    id: "/collections_/$collectionId",
    path: "/collections/$collectionId",
    getParentRoute: () => ConsoleProductionRouteRoute,
  } as any);
const ConsoleProductionEpisodesEpisodeIdRoute =
  ConsoleProductionEpisodesEpisodeIdRouteImport.update({
    id: "/episodes_/$episodeId",
    path: "/episodes/$episodeId",
    getParentRoute: () => ConsoleProductionRouteRoute,
  } as any);
const ConsoleProductionPodsIndexRoute =
  ConsoleProductionPodsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsoleProductionPodsRoute,
  } as any);
const ConsoleSettingsOrganizationsIndexRoute =
  ConsoleSettingsOrganizationsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsoleSettingsOrganizationsRoute,
  } as any);
const ConsoleSettingsOrganizationsOrganizationIdRoute =
  ConsoleSettingsOrganizationsOrganizationIdRouteImport.update({
    id: "/$organizationId",
    path: "/$organizationId",
    getParentRoute: () => ConsoleSettingsOrganizationsRoute,
  } as any);
const ConsoleSettingsPlatformIndexRoute =
  ConsoleSettingsPlatformIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsoleSettingsPlatformRouteRoute,
  } as any);
const ConsoleSettingsPlatformActAsRoute =
  ConsoleSettingsPlatformActAsRouteImport.update({
    id: "/act-as",
    path: "/act-as",
    getParentRoute: () => ConsoleSettingsPlatformRouteRoute,
  } as any);
const ConsoleSettingsPlatformAudiencesRoute =
  ConsoleSettingsPlatformAudiencesRouteImport.update({
    id: "/audiences",
    path: "/audiences",
    getParentRoute: () => ConsoleSettingsPlatformRouteRoute,
  } as any);
const ConsoleSettingsPlatformNodesRoute =
  ConsoleSettingsPlatformNodesRouteImport.update({
    id: "/nodes",
    path: "/nodes",
    getParentRoute: () => ConsoleSettingsPlatformRouteRoute,
  } as any);
const ConsoleSettingsPlatformOrganizationsRoute =
  ConsoleSettingsPlatformOrganizationsRouteImport.update({
    id: "/organizations",
    path: "/organizations",
    getParentRoute: () => ConsoleSettingsPlatformRouteRoute,
  } as any);
const ConsoleSettingsPlatformPrincipalsRoute =
  ConsoleSettingsPlatformPrincipalsRouteImport.update({
    id: "/principals",
    path: "/principals",
    getParentRoute: () => ConsoleSettingsPlatformRouteRoute,
  } as any);
const ConsoleSettingsProjectsIndexRoute =
  ConsoleSettingsProjectsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsoleSettingsProjectsRoute,
  } as any);
const ConsoleSettingsProjectsProjectIdRoute =
  ConsoleSettingsProjectsProjectIdRouteImport.update({
    id: "/$projectId",
    path: "/$projectId",
    getParentRoute: () => ConsoleSettingsProjectsRoute,
  } as any);
const ConsoleTeleoperatorsCockpitTicketIdRoute =
  ConsoleTeleoperatorsCockpitTicketIdRouteImport.update({
    id: "/cockpit/$ticketId",
    path: "/cockpit/$ticketId",
    getParentRoute: () => ConsoleTeleoperatorsRouteRoute,
  } as any);
const ConsolePOrgProjectIndexRoute = ConsolePOrgProjectIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ConsolePOrgProjectRoute,
} as any);
const ConsolePOrgProjectBuildWorldsRouteRoute =
  ConsolePOrgProjectBuildWorldsRouteRouteImport.update({
    id: "/build-worlds",
    path: "/build-worlds",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectDeployRouteRoute =
  ConsolePOrgProjectDeployRouteRouteImport.update({
    id: "/deploy",
    path: "/deploy",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectLibraryRouteRoute =
  ConsolePOrgProjectLibraryRouteRouteImport.update({
    id: "/library",
    path: "/library",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectOperationsRoute =
  ConsolePOrgProjectOperationsRouteImport.update({
    id: "/operations",
    path: "/operations",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectOrdersRoute =
  ConsolePOrgProjectOrdersRouteImport.update({
    id: "/orders",
    path: "/orders",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectReportsRouteRoute =
  ConsolePOrgProjectReportsRouteRouteImport.update({
    id: "/reports",
    path: "/reports",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectSettingsRoute =
  ConsolePOrgProjectSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectSimulateRouteRoute =
  ConsolePOrgProjectSimulateRouteRouteImport.update({
    id: "/simulate",
    path: "/simulate",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectSupplyRouteRoute =
  ConsolePOrgProjectSupplyRouteRouteImport.update({
    id: "/supply",
    path: "/supply",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectTasksRoute = ConsolePOrgProjectTasksRouteImport.update({
  id: "/tasks",
  path: "/tasks",
  getParentRoute: () => ConsolePOrgProjectRoute,
} as any);
const ConsolePOrgProjectTrainingRouteRoute =
  ConsolePOrgProjectTrainingRouteRouteImport.update({
    id: "/training",
    path: "/training",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectWorkAtlasRouteRoute =
  ConsolePOrgProjectWorkAtlasRouteRouteImport.update({
    id: "/work-atlas",
    path: "/work-atlas",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsoleProductionPodsPodIdIndexRoute =
  ConsoleProductionPodsPodIdIndexRouteImport.update({
    id: "/$podId/",
    path: "/$podId/",
    getParentRoute: () => ConsoleProductionPodsRoute,
  } as any);
const ConsoleProductionPodsPodIdEpisodeIdRoute =
  ConsoleProductionPodsPodIdEpisodeIdRouteImport.update({
    id: "/pods_/$podId/$episodeId",
    path: "/pods/$podId/$episodeId",
    getParentRoute: () => ConsoleProductionRouteRoute,
  } as any);
const ConsoleSettingsOrganizationsOrganizationIdBillingRoute =
  ConsoleSettingsOrganizationsOrganizationIdBillingRouteImport.update({
    id: "/$organizationId_/billing",
    path: "/$organizationId/billing",
    getParentRoute: () => ConsoleSettingsOrganizationsRoute,
  } as any);
const ConsolePOrgProjectBuildWorldsIndexRoute =
  ConsolePOrgProjectBuildWorldsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectBuildWorldsRouteRoute,
  } as any);
const ConsolePOrgProjectBuildWorldsAssetsRoute =
  ConsolePOrgProjectBuildWorldsAssetsRouteImport.update({
    id: "/assets",
    path: "/assets",
    getParentRoute: () => ConsolePOrgProjectBuildWorldsRouteRoute,
  } as any);
const ConsolePOrgProjectBuildWorldsCreateRoute =
  ConsolePOrgProjectBuildWorldsCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => ConsolePOrgProjectBuildWorldsRouteRoute,
  } as any);
const ConsolePOrgProjectDeployIndexRoute =
  ConsolePOrgProjectDeployIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectDeployRouteRoute,
  } as any);
const ConsolePOrgProjectDeployRobotRoute =
  ConsolePOrgProjectDeployRobotRouteImport.update({
    id: "/$robot",
    path: "/$robot",
    getParentRoute: () => ConsolePOrgProjectDeployRouteRoute,
  } as any);
const ConsolePOrgProjectDeployStationsRoute =
  ConsolePOrgProjectDeployStationsRouteImport.update({
    id: "/stations",
    path: "/stations",
    getParentRoute: () => ConsolePOrgProjectDeployRouteRoute,
  } as any);
const ConsolePOrgProjectLibraryIndexRoute =
  ConsolePOrgProjectLibraryIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);
const ConsolePOrgProjectLibraryIssuesRoute =
  ConsolePOrgProjectLibraryIssuesRouteImport.update({
    id: "/issues",
    path: "/issues",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);
const ConsolePOrgProjectLibraryMapRoute =
  ConsolePOrgProjectLibraryMapRouteImport.update({
    id: "/map",
    path: "/map",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);
const ConsolePOrgProjectLibrarySearchRoute =
  ConsolePOrgProjectLibrarySearchRouteImport.update({
    id: "/search",
    path: "/search",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);
const ConsolePOrgProjectLibrarySemanticRoute =
  ConsolePOrgProjectLibrarySemanticRouteImport.update({
    id: "/semantic",
    path: "/semantic",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);
const ConsolePOrgProjectLoopIndexRoute =
  ConsolePOrgProjectLoopIndexRouteImport.update({
    id: "/loop/",
    path: "/loop/",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectLoopBoardRoute =
  ConsolePOrgProjectLoopBoardRouteImport.update({
    id: "/loop/board",
    path: "/loop/board",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectLoopManagerRoute =
  ConsolePOrgProjectLoopManagerRouteImport.update({
    id: "/loop/manager",
    path: "/loop/manager",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectLoopTeamRoute =
  ConsolePOrgProjectLoopTeamRouteImport.update({
    id: "/loop/team",
    path: "/loop/team",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectOrdersIndexRoute =
  ConsolePOrgProjectOrdersIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectOrdersRoute,
  } as any);
const ConsolePOrgProjectReportsIndexRoute =
  ConsolePOrgProjectReportsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectReportsRouteRoute,
  } as any);
const ConsolePOrgProjectReportsModelRoute =
  ConsolePOrgProjectReportsModelRouteImport.update({
    id: "/model",
    path: "/model",
    getParentRoute: () => ConsolePOrgProjectReportsRouteRoute,
  } as any);
const ConsolePOrgProjectReportsNewRoute =
  ConsolePOrgProjectReportsNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => ConsolePOrgProjectReportsRouteRoute,
  } as any);
const ConsolePOrgProjectRobotsIndexRoute =
  ConsolePOrgProjectRobotsIndexRouteImport.update({
    id: "/robots/",
    path: "/robots/",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectRobotsComposeRoute =
  ConsolePOrgProjectRobotsComposeRouteImport.update({
    id: "/robots/compose",
    path: "/robots/compose",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectSimulateIndexRoute =
  ConsolePOrgProjectSimulateIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectSimulateRouteRoute,
  } as any);
const ConsolePOrgProjectSimulateCreateRoute =
  ConsolePOrgProjectSimulateCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => ConsolePOrgProjectSimulateRouteRoute,
  } as any);
const ConsolePOrgProjectSimulateRunsRoute =
  ConsolePOrgProjectSimulateRunsRouteImport.update({
    id: "/runs",
    path: "/runs",
    getParentRoute: () => ConsolePOrgProjectSimulateRouteRoute,
  } as any);
const ConsolePOrgProjectSimulateSessionsRoute =
  ConsolePOrgProjectSimulateSessionsRouteImport.update({
    id: "/sessions",
    path: "/sessions",
    getParentRoute: () => ConsolePOrgProjectSimulateRouteRoute,
  } as any);
const ConsolePOrgProjectSupplyIndexRoute =
  ConsolePOrgProjectSupplyIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectSupplyRouteRoute,
  } as any);
const ConsolePOrgProjectSupplyOrdersRoute =
  ConsolePOrgProjectSupplyOrdersRouteImport.update({
    id: "/orders",
    path: "/orders",
    getParentRoute: () => ConsolePOrgProjectSupplyRouteRoute,
  } as any);
const ConsolePOrgProjectSupplyShipmentsRoute =
  ConsolePOrgProjectSupplyShipmentsRouteImport.update({
    id: "/shipments",
    path: "/shipments",
    getParentRoute: () => ConsolePOrgProjectSupplyRouteRoute,
  } as any);
const ConsolePOrgProjectTasksIndexRoute =
  ConsolePOrgProjectTasksIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectTasksRoute,
  } as any);
const ConsolePOrgProjectTasksTaskIdRoute =
  ConsolePOrgProjectTasksTaskIdRouteImport.update({
    id: "/$taskId",
    path: "/$taskId",
    getParentRoute: () => ConsolePOrgProjectTasksRoute,
  } as any);
const ConsolePOrgProjectTrainingIndexRoute =
  ConsolePOrgProjectTrainingIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectTrainingRouteRoute,
  } as any);
const ConsolePOrgProjectTrainingCompareRoute =
  ConsolePOrgProjectTrainingCompareRouteImport.update({
    id: "/compare",
    path: "/compare",
    getParentRoute: () => ConsolePOrgProjectTrainingRouteRoute,
  } as any);
const ConsolePOrgProjectWorkAtlasIndexRoute =
  ConsolePOrgProjectWorkAtlasIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectWorkAtlasRouteRoute,
  } as any);
const ConsolePOrgProjectWorkAtlasHomeRoute =
  ConsolePOrgProjectWorkAtlasHomeRouteImport.update({
    id: "/home",
    path: "/home",
    getParentRoute: () => ConsolePOrgProjectWorkAtlasRouteRoute,
  } as any);
const ConsolePOrgProjectWorkAtlasOccupationsRoute =
  ConsolePOrgProjectWorkAtlasOccupationsRouteImport.update({
    id: "/occupations",
    path: "/occupations",
    getParentRoute: () => ConsolePOrgProjectWorkAtlasRouteRoute,
  } as any);
const ConsolePOrgProjectWorkAtlasOpportunitiesRoute =
  ConsolePOrgProjectWorkAtlasOpportunitiesRouteImport.update({
    id: "/opportunities",
    path: "/opportunities",
    getParentRoute: () => ConsolePOrgProjectWorkAtlasRouteRoute,
  } as any);
const ConsolePOrgProjectWorkAtlasSkillsRoute =
  ConsolePOrgProjectWorkAtlasSkillsRouteImport.update({
    id: "/skills",
    path: "/skills",
    getParentRoute: () => ConsolePOrgProjectWorkAtlasRouteRoute,
  } as any);
const ConsolePOrgProjectWorkAtlasTasksRoute =
  ConsolePOrgProjectWorkAtlasTasksRouteImport.update({
    id: "/tasks",
    path: "/tasks",
    getParentRoute: () => ConsolePOrgProjectWorkAtlasRouteRoute,
  } as any);
const ConsolePOrgProjectBuildWorldsAssetsWorldIdRoute =
  ConsolePOrgProjectBuildWorldsAssetsWorldIdRouteImport.update({
    id: "/$worldId",
    path: "/$worldId",
    getParentRoute: () => ConsolePOrgProjectBuildWorldsAssetsRoute,
  } as any);
const ConsolePOrgProjectBuildWorldsDraftsDraftIdRoute =
  ConsolePOrgProjectBuildWorldsDraftsDraftIdRouteImport.update({
    id: "/drafts/$draftId",
    path: "/drafts/$draftId",
    getParentRoute: () => ConsolePOrgProjectBuildWorldsRouteRoute,
  } as any);
const ConsolePOrgProjectDeployLaddersSplatRoute =
  ConsolePOrgProjectDeployLaddersSplatRouteImport.update({
    id: "/ladders/$",
    path: "/ladders/$",
    getParentRoute: () => ConsolePOrgProjectDeployRouteRoute,
  } as any);
const ConsolePOrgProjectDeployStationsIndexRoute =
  ConsolePOrgProjectDeployStationsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsolePOrgProjectDeployStationsRoute,
  } as any);
const ConsolePOrgProjectDeployStationsStationIdRoute =
  ConsolePOrgProjectDeployStationsStationIdRouteImport.update({
    id: "/$stationId",
    path: "/$stationId",
    getParentRoute: () => ConsolePOrgProjectDeployStationsRoute,
  } as any);
const ConsolePOrgProjectLibraryAgentsAgentIdRoute =
  ConsolePOrgProjectLibraryAgentsAgentIdRouteImport.update({
    id: "/agents/$agentId",
    path: "/agents/$agentId",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);
const ConsolePOrgProjectLibraryContractsIdRoute =
  ConsolePOrgProjectLibraryContractsIdRouteImport.update({
    id: "/contracts/$id",
    path: "/contracts/$id",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);
const ConsolePOrgProjectLibraryItemsNameRoute =
  ConsolePOrgProjectLibraryItemsNameRouteImport.update({
    id: "/items/$name",
    path: "/items/$name",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);
const ConsolePOrgProjectReportsNameIndexRoute =
  ConsolePOrgProjectReportsNameIndexRouteImport.update({
    id: "/$name/",
    path: "/$name/",
    getParentRoute: () => ConsolePOrgProjectReportsRouteRoute,
  } as any);
const ConsolePOrgProjectReportsNameChangesRoute =
  ConsolePOrgProjectReportsNameChangesRouteImport.update({
    id: "/$name/changes",
    path: "/$name/changes",
    getParentRoute: () => ConsolePOrgProjectReportsRouteRoute,
  } as any);
const ConsolePOrgProjectReportsNameEditRoute =
  ConsolePOrgProjectReportsNameEditRouteImport.update({
    id: "/$name/edit",
    path: "/$name/edit",
    getParentRoute: () => ConsolePOrgProjectReportsRouteRoute,
  } as any);
const ConsolePOrgProjectRobotsBodiesBodyRoute =
  ConsolePOrgProjectRobotsBodiesBodyRouteImport.update({
    id: "/robots/bodies/$body",
    path: "/robots/bodies/$body",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectSimulateAssetsWorldIdRoute =
  ConsolePOrgProjectSimulateAssetsWorldIdRouteImport.update({
    id: "/assets/$worldId",
    path: "/assets/$worldId",
    getParentRoute: () => ConsolePOrgProjectSimulateRouteRoute,
  } as any);
const ConsolePOrgProjectSimulateDraftsIndexRoute =
  ConsolePOrgProjectSimulateDraftsIndexRouteImport.update({
    id: "/drafts/",
    path: "/drafts/",
    getParentRoute: () => ConsolePOrgProjectSimulateRouteRoute,
  } as any);
const ConsolePOrgProjectSimulateDraftsDraftIdRoute =
  ConsolePOrgProjectSimulateDraftsDraftIdRouteImport.update({
    id: "/drafts/$draftId",
    path: "/drafts/$draftId",
    getParentRoute: () => ConsolePOrgProjectSimulateRouteRoute,
  } as any);
const ConsolePOrgProjectTrainingJobsJobIdRoute =
  ConsolePOrgProjectTrainingJobsJobIdRouteImport.update({
    id: "/jobs/$jobId",
    path: "/jobs/$jobId",
    getParentRoute: () => ConsolePOrgProjectTrainingRouteRoute,
  } as any);
const ConsolePOrgProjectTrainingResearchIndexRoute =
  ConsolePOrgProjectTrainingResearchIndexRouteImport.update({
    id: "/research/",
    path: "/research/",
    getParentRoute: () => ConsolePOrgProjectTrainingRouteRoute,
  } as any);
const ConsolePOrgProjectTrainingResearchSessionNameRoute =
  ConsolePOrgProjectTrainingResearchSessionNameRouteImport.update({
    id: "/research/$sessionName",
    path: "/research/$sessionName",
    getParentRoute: () => ConsolePOrgProjectTrainingRouteRoute,
  } as any);
const ConsolePOrgProjectTrainingRunsIndexRoute =
  ConsolePOrgProjectTrainingRunsIndexRouteImport.update({
    id: "/runs/",
    path: "/runs/",
    getParentRoute: () => ConsolePOrgProjectTrainingRouteRoute,
  } as any);
const ConsolePOrgProjectTrainingRunsRunIdRoute =
  ConsolePOrgProjectTrainingRunsRunIdRouteImport.update({
    id: "/runs/$runId",
    path: "/runs/$runId",
    getParentRoute: () => ConsolePOrgProjectTrainingRouteRoute,
  } as any);
const ConsolePOrgProjectDeployRobotSessionsSessionRoute =
  ConsolePOrgProjectDeployRobotSessionsSessionRouteImport.update({
    id: "/$robot_/sessions/$session",
    path: "/$robot/sessions/$session",
    getParentRoute: () => ConsolePOrgProjectDeployRouteRoute,
  } as any);
const ConsolePOrgProjectLibraryDatasetsNameIndexRoute =
  ConsolePOrgProjectLibraryDatasetsNameIndexRouteImport.update({
    id: "/datasets/$name/",
    path: "/datasets/$name/",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);
const ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRoute =
  ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRouteImport.update({
    id: "/episodes/$sessionId/$episodeId",
    path: "/episodes/$sessionId/$episodeId",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);
const ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125Route =
  ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125RouteImport.update({
    id: "/loop/agent/$agentId/{-$sessionId}",
    path: "/loop/agent/$agentId/{-$sessionId}",
    getParentRoute: () => ConsolePOrgProjectRoute,
  } as any);
const ConsolePOrgProjectReportsNameVersionsVersionRoute =
  ConsolePOrgProjectReportsNameVersionsVersionRouteImport.update({
    id: "/$name/versions/$version",
    path: "/$name/versions/$version",
    getParentRoute: () => ConsolePOrgProjectReportsRouteRoute,
  } as any);
const ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRoute =
  ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRouteImport.update({
    id: "/datasets/$name/segments/$segmentId",
    path: "/datasets/$name/segments/$segmentId",
    getParentRoute: () => ConsolePOrgProjectLibraryRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof ConsoleIndexRoute;
  "/headset": typeof HeadsetRoute;
  "/signed-out": typeof SignedOutRoute;
  "/label": typeof ConsoleLabelRouteRouteWithChildren;
  "/operations": typeof ConsoleOperationsRouteRouteWithChildren;
  "/production": typeof ConsoleProductionRouteRouteWithChildren;
  "/settings": typeof ConsoleSettingsRouteRouteWithChildren;
  "/teleoperators": typeof ConsoleTeleoperatorsRouteRouteWithChildren;
  "/$": typeof ConsoleSplatRoute;
  "/projects": typeof ConsoleProjectsRouteWithChildren;
  "/settings/platform": typeof ConsoleSettingsPlatformRouteRouteWithChildren;
  "/label/admin": typeof ConsoleLabelAdminRoute;
  "/label/principal": typeof ConsoleLabelPrincipalRoute;
  "/label/qc": typeof ConsoleLabelQcRouteWithChildren;
  "/operations/releases": typeof ConsoleOperationsReleasesRoute;
  "/production/activity": typeof ConsoleProductionActivityRoute;
  "/production/checks": typeof ConsoleProductionChecksRoute;
  "/production/collections": typeof ConsoleProductionCollectionsRoute;
  "/production/episodes": typeof ConsoleProductionEpisodesRoute;
  "/production/operators": typeof ConsoleProductionOperatorsRoute;
  "/production/people": typeof ConsoleProductionPeopleRoute;
  "/production/pods": typeof ConsoleProductionPodsRouteWithChildren;
  "/production/uploads": typeof ConsoleProductionUploadsRoute;
  "/settings/billing": typeof ConsoleSettingsBillingRoute;
  "/settings/keys": typeof ConsoleSettingsKeysRoute;
  "/settings/operators": typeof ConsoleSettingsOperatorsRoute;
  "/settings/organizations": typeof ConsoleSettingsOrganizationsRouteWithChildren;
  "/settings/people": typeof ConsoleSettingsPeopleRoute;
  "/settings/projects": typeof ConsoleSettingsProjectsRouteWithChildren;
  "/settings/sessions": typeof ConsoleSettingsSessionsRoute;
  "/supervise/$": typeof ConsoleSuperviseSplatRoute;
  "/teleoperators/people": typeof ConsoleTeleoperatorsPeopleRoute;
  "/teleoperators/sessions": typeof ConsoleTeleoperatorsSessionsRoute;
  "/label/": typeof ConsoleLabelIndexRoute;
  "/operations/": typeof ConsoleOperationsIndexRoute;
  "/production/": typeof ConsoleProductionIndexRoute;
  "/projects/": typeof ConsoleProjectsIndexRoute;
  "/settings/": typeof ConsoleSettingsIndexRoute;
  "/teleoperators/": typeof ConsoleTeleoperatorsIndexRoute;
  "/label/annotate/$episodeId": typeof ConsoleLabelAnnotateEpisodeIdRoute;
  "/label/audit/$episodeId": typeof ConsoleLabelAuditEpisodeIdRoute;
  "/label/qc/accuracy": typeof ConsoleLabelQcAccuracyRoute;
  "/p/$org/$project": typeof ConsolePOrgProjectRouteWithChildren;
  "/production/collections/$collectionId": typeof ConsoleProductionCollectionsCollectionIdRoute;
  "/production/episodes/$episodeId": typeof ConsoleProductionEpisodesEpisodeIdRoute;
  "/settings/organizations/$organizationId": typeof ConsoleSettingsOrganizationsOrganizationIdRoute;
  "/settings/platform/act-as": typeof ConsoleSettingsPlatformActAsRoute;
  "/settings/platform/audiences": typeof ConsoleSettingsPlatformAudiencesRoute;
  "/settings/platform/nodes": typeof ConsoleSettingsPlatformNodesRoute;
  "/settings/platform/organizations": typeof ConsoleSettingsPlatformOrganizationsRoute;
  "/settings/platform/principals": typeof ConsoleSettingsPlatformPrincipalsRoute;
  "/settings/projects/$projectId": typeof ConsoleSettingsProjectsProjectIdRoute;
  "/teleoperators/cockpit/$ticketId": typeof ConsoleTeleoperatorsCockpitTicketIdRoute;
  "/label/audit/": typeof ConsoleLabelAuditIndexRoute;
  "/label/qc/": typeof ConsoleLabelQcIndexRoute;
  "/production/pods/": typeof ConsoleProductionPodsIndexRoute;
  "/settings/organizations/": typeof ConsoleSettingsOrganizationsIndexRoute;
  "/settings/platform/": typeof ConsoleSettingsPlatformIndexRoute;
  "/settings/projects/": typeof ConsoleSettingsProjectsIndexRoute;
  "/p/$org/$project/build-worlds": typeof ConsolePOrgProjectBuildWorldsRouteRouteWithChildren;
  "/p/$org/$project/deploy": typeof ConsolePOrgProjectDeployRouteRouteWithChildren;
  "/p/$org/$project/library": typeof ConsolePOrgProjectLibraryRouteRouteWithChildren;
  "/p/$org/$project/reports": typeof ConsolePOrgProjectReportsRouteRouteWithChildren;
  "/p/$org/$project/simulate": typeof ConsolePOrgProjectSimulateRouteRouteWithChildren;
  "/p/$org/$project/supply": typeof ConsolePOrgProjectSupplyRouteRouteWithChildren;
  "/p/$org/$project/training": typeof ConsolePOrgProjectTrainingRouteRouteWithChildren;
  "/p/$org/$project/work-atlas": typeof ConsolePOrgProjectWorkAtlasRouteRouteWithChildren;
  "/p/$org/$project/operations": typeof ConsolePOrgProjectOperationsRoute;
  "/p/$org/$project/orders": typeof ConsolePOrgProjectOrdersRouteWithChildren;
  "/p/$org/$project/settings": typeof ConsolePOrgProjectSettingsRoute;
  "/p/$org/$project/tasks": typeof ConsolePOrgProjectTasksRouteWithChildren;
  "/production/pods/$podId/$episodeId": typeof ConsoleProductionPodsPodIdEpisodeIdRoute;
  "/settings/organizations/$organizationId/billing": typeof ConsoleSettingsOrganizationsOrganizationIdBillingRoute;
  "/p/$org/$project/": typeof ConsolePOrgProjectIndexRoute;
  "/production/pods/$podId/": typeof ConsoleProductionPodsPodIdIndexRoute;
  "/p/$org/$project/build-worlds/assets": typeof ConsolePOrgProjectBuildWorldsAssetsRouteWithChildren;
  "/p/$org/$project/build-worlds/create": typeof ConsolePOrgProjectBuildWorldsCreateRoute;
  "/p/$org/$project/deploy/$robot": typeof ConsolePOrgProjectDeployRobotRoute;
  "/p/$org/$project/deploy/stations": typeof ConsolePOrgProjectDeployStationsRouteWithChildren;
  "/p/$org/$project/library/issues": typeof ConsolePOrgProjectLibraryIssuesRoute;
  "/p/$org/$project/library/map": typeof ConsolePOrgProjectLibraryMapRoute;
  "/p/$org/$project/library/search": typeof ConsolePOrgProjectLibrarySearchRoute;
  "/p/$org/$project/library/semantic": typeof ConsolePOrgProjectLibrarySemanticRoute;
  "/p/$org/$project/loop/board": typeof ConsolePOrgProjectLoopBoardRoute;
  "/p/$org/$project/loop/manager": typeof ConsolePOrgProjectLoopManagerRoute;
  "/p/$org/$project/loop/team": typeof ConsolePOrgProjectLoopTeamRoute;
  "/p/$org/$project/reports/model": typeof ConsolePOrgProjectReportsModelRoute;
  "/p/$org/$project/reports/new": typeof ConsolePOrgProjectReportsNewRoute;
  "/p/$org/$project/robots/compose": typeof ConsolePOrgProjectRobotsComposeRoute;
  "/p/$org/$project/simulate/create": typeof ConsolePOrgProjectSimulateCreateRoute;
  "/p/$org/$project/simulate/runs": typeof ConsolePOrgProjectSimulateRunsRoute;
  "/p/$org/$project/simulate/sessions": typeof ConsolePOrgProjectSimulateSessionsRoute;
  "/p/$org/$project/supply/orders": typeof ConsolePOrgProjectSupplyOrdersRoute;
  "/p/$org/$project/supply/shipments": typeof ConsolePOrgProjectSupplyShipmentsRoute;
  "/p/$org/$project/tasks/$taskId": typeof ConsolePOrgProjectTasksTaskIdRoute;
  "/p/$org/$project/training/compare": typeof ConsolePOrgProjectTrainingCompareRoute;
  "/p/$org/$project/work-atlas/home": typeof ConsolePOrgProjectWorkAtlasHomeRoute;
  "/p/$org/$project/work-atlas/occupations": typeof ConsolePOrgProjectWorkAtlasOccupationsRoute;
  "/p/$org/$project/work-atlas/opportunities": typeof ConsolePOrgProjectWorkAtlasOpportunitiesRoute;
  "/p/$org/$project/work-atlas/skills": typeof ConsolePOrgProjectWorkAtlasSkillsRoute;
  "/p/$org/$project/work-atlas/tasks": typeof ConsolePOrgProjectWorkAtlasTasksRoute;
  "/p/$org/$project/build-worlds/": typeof ConsolePOrgProjectBuildWorldsIndexRoute;
  "/p/$org/$project/deploy/": typeof ConsolePOrgProjectDeployIndexRoute;
  "/p/$org/$project/library/": typeof ConsolePOrgProjectLibraryIndexRoute;
  "/p/$org/$project/loop/": typeof ConsolePOrgProjectLoopIndexRoute;
  "/p/$org/$project/orders/": typeof ConsolePOrgProjectOrdersIndexRoute;
  "/p/$org/$project/reports/": typeof ConsolePOrgProjectReportsIndexRoute;
  "/p/$org/$project/robots/": typeof ConsolePOrgProjectRobotsIndexRoute;
  "/p/$org/$project/simulate/": typeof ConsolePOrgProjectSimulateIndexRoute;
  "/p/$org/$project/supply/": typeof ConsolePOrgProjectSupplyIndexRoute;
  "/p/$org/$project/tasks/": typeof ConsolePOrgProjectTasksIndexRoute;
  "/p/$org/$project/training/": typeof ConsolePOrgProjectTrainingIndexRoute;
  "/p/$org/$project/work-atlas/": typeof ConsolePOrgProjectWorkAtlasIndexRoute;
  "/p/$org/$project/build-worlds/assets/$worldId": typeof ConsolePOrgProjectBuildWorldsAssetsWorldIdRoute;
  "/p/$org/$project/build-worlds/drafts/$draftId": typeof ConsolePOrgProjectBuildWorldsDraftsDraftIdRoute;
  "/p/$org/$project/deploy/ladders/$": typeof ConsolePOrgProjectDeployLaddersSplatRoute;
  "/p/$org/$project/deploy/stations/$stationId": typeof ConsolePOrgProjectDeployStationsStationIdRoute;
  "/p/$org/$project/library/agents/$agentId": typeof ConsolePOrgProjectLibraryAgentsAgentIdRoute;
  "/p/$org/$project/library/contracts/$id": typeof ConsolePOrgProjectLibraryContractsIdRoute;
  "/p/$org/$project/library/items/$name": typeof ConsolePOrgProjectLibraryItemsNameRoute;
  "/p/$org/$project/reports/$name/changes": typeof ConsolePOrgProjectReportsNameChangesRoute;
  "/p/$org/$project/reports/$name/edit": typeof ConsolePOrgProjectReportsNameEditRoute;
  "/p/$org/$project/robots/bodies/$body": typeof ConsolePOrgProjectRobotsBodiesBodyRoute;
  "/p/$org/$project/simulate/assets/$worldId": typeof ConsolePOrgProjectSimulateAssetsWorldIdRoute;
  "/p/$org/$project/simulate/drafts/$draftId": typeof ConsolePOrgProjectSimulateDraftsDraftIdRoute;
  "/p/$org/$project/training/jobs/$jobId": typeof ConsolePOrgProjectTrainingJobsJobIdRoute;
  "/p/$org/$project/training/research/$sessionName": typeof ConsolePOrgProjectTrainingResearchSessionNameRoute;
  "/p/$org/$project/training/runs/$runId": typeof ConsolePOrgProjectTrainingRunsRunIdRoute;
  "/p/$org/$project/deploy/stations/": typeof ConsolePOrgProjectDeployStationsIndexRoute;
  "/p/$org/$project/reports/$name/": typeof ConsolePOrgProjectReportsNameIndexRoute;
  "/p/$org/$project/simulate/drafts/": typeof ConsolePOrgProjectSimulateDraftsIndexRoute;
  "/p/$org/$project/training/research/": typeof ConsolePOrgProjectTrainingResearchIndexRoute;
  "/p/$org/$project/training/runs/": typeof ConsolePOrgProjectTrainingRunsIndexRoute;
  "/p/$org/$project/deploy/$robot/sessions/$session": typeof ConsolePOrgProjectDeployRobotSessionsSessionRoute;
  "/p/$org/$project/library/episodes/$sessionId/$episodeId": typeof ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRoute;
  "/p/$org/$project/loop/agent/$agentId/{-$sessionId}": typeof ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125Route;
  "/p/$org/$project/reports/$name/versions/$version": typeof ConsolePOrgProjectReportsNameVersionsVersionRoute;
  "/p/$org/$project/library/datasets/$name/": typeof ConsolePOrgProjectLibraryDatasetsNameIndexRoute;
  "/p/$org/$project/library/datasets/$name/segments/$segmentId": typeof ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRoute;
}
export interface FileRoutesByTo {
  "/headset": typeof HeadsetRoute;
  "/signed-out": typeof SignedOutRoute;
  "/$": typeof ConsoleSplatRoute;
  "/": typeof ConsoleIndexRoute;
  "/label/admin": typeof ConsoleLabelAdminRoute;
  "/label/principal": typeof ConsoleLabelPrincipalRoute;
  "/operations/releases": typeof ConsoleOperationsReleasesRoute;
  "/production/activity": typeof ConsoleProductionActivityRoute;
  "/production/checks": typeof ConsoleProductionChecksRoute;
  "/production/collections": typeof ConsoleProductionCollectionsRoute;
  "/production/episodes": typeof ConsoleProductionEpisodesRoute;
  "/production/operators": typeof ConsoleProductionOperatorsRoute;
  "/production/people": typeof ConsoleProductionPeopleRoute;
  "/production/uploads": typeof ConsoleProductionUploadsRoute;
  "/settings/billing": typeof ConsoleSettingsBillingRoute;
  "/settings/keys": typeof ConsoleSettingsKeysRoute;
  "/settings/operators": typeof ConsoleSettingsOperatorsRoute;
  "/settings/people": typeof ConsoleSettingsPeopleRoute;
  "/settings/sessions": typeof ConsoleSettingsSessionsRoute;
  "/supervise/$": typeof ConsoleSuperviseSplatRoute;
  "/teleoperators/people": typeof ConsoleTeleoperatorsPeopleRoute;
  "/teleoperators/sessions": typeof ConsoleTeleoperatorsSessionsRoute;
  "/label": typeof ConsoleLabelIndexRoute;
  "/operations": typeof ConsoleOperationsIndexRoute;
  "/production": typeof ConsoleProductionIndexRoute;
  "/projects": typeof ConsoleProjectsIndexRoute;
  "/settings": typeof ConsoleSettingsIndexRoute;
  "/teleoperators": typeof ConsoleTeleoperatorsIndexRoute;
  "/label/annotate/$episodeId": typeof ConsoleLabelAnnotateEpisodeIdRoute;
  "/label/audit/$episodeId": typeof ConsoleLabelAuditEpisodeIdRoute;
  "/label/qc/accuracy": typeof ConsoleLabelQcAccuracyRoute;
  "/production/collections/$collectionId": typeof ConsoleProductionCollectionsCollectionIdRoute;
  "/production/episodes/$episodeId": typeof ConsoleProductionEpisodesEpisodeIdRoute;
  "/settings/organizations/$organizationId": typeof ConsoleSettingsOrganizationsOrganizationIdRoute;
  "/settings/platform/act-as": typeof ConsoleSettingsPlatformActAsRoute;
  "/settings/platform/audiences": typeof ConsoleSettingsPlatformAudiencesRoute;
  "/settings/platform/nodes": typeof ConsoleSettingsPlatformNodesRoute;
  "/settings/platform/organizations": typeof ConsoleSettingsPlatformOrganizationsRoute;
  "/settings/platform/principals": typeof ConsoleSettingsPlatformPrincipalsRoute;
  "/settings/projects/$projectId": typeof ConsoleSettingsProjectsProjectIdRoute;
  "/teleoperators/cockpit/$ticketId": typeof ConsoleTeleoperatorsCockpitTicketIdRoute;
  "/label/audit": typeof ConsoleLabelAuditIndexRoute;
  "/label/qc": typeof ConsoleLabelQcIndexRoute;
  "/production/pods": typeof ConsoleProductionPodsIndexRoute;
  "/settings/organizations": typeof ConsoleSettingsOrganizationsIndexRoute;
  "/settings/platform": typeof ConsoleSettingsPlatformIndexRoute;
  "/settings/projects": typeof ConsoleSettingsProjectsIndexRoute;
  "/p/$org/$project/operations": typeof ConsolePOrgProjectOperationsRoute;
  "/p/$org/$project/settings": typeof ConsolePOrgProjectSettingsRoute;
  "/production/pods/$podId/$episodeId": typeof ConsoleProductionPodsPodIdEpisodeIdRoute;
  "/settings/organizations/$organizationId/billing": typeof ConsoleSettingsOrganizationsOrganizationIdBillingRoute;
  "/p/$org/$project": typeof ConsolePOrgProjectIndexRoute;
  "/production/pods/$podId": typeof ConsoleProductionPodsPodIdIndexRoute;
  "/p/$org/$project/build-worlds/assets": typeof ConsolePOrgProjectBuildWorldsAssetsRouteWithChildren;
  "/p/$org/$project/build-worlds/create": typeof ConsolePOrgProjectBuildWorldsCreateRoute;
  "/p/$org/$project/deploy/$robot": typeof ConsolePOrgProjectDeployRobotRoute;
  "/p/$org/$project/library/issues": typeof ConsolePOrgProjectLibraryIssuesRoute;
  "/p/$org/$project/library/map": typeof ConsolePOrgProjectLibraryMapRoute;
  "/p/$org/$project/library/search": typeof ConsolePOrgProjectLibrarySearchRoute;
  "/p/$org/$project/library/semantic": typeof ConsolePOrgProjectLibrarySemanticRoute;
  "/p/$org/$project/loop/board": typeof ConsolePOrgProjectLoopBoardRoute;
  "/p/$org/$project/loop/manager": typeof ConsolePOrgProjectLoopManagerRoute;
  "/p/$org/$project/loop/team": typeof ConsolePOrgProjectLoopTeamRoute;
  "/p/$org/$project/reports/model": typeof ConsolePOrgProjectReportsModelRoute;
  "/p/$org/$project/reports/new": typeof ConsolePOrgProjectReportsNewRoute;
  "/p/$org/$project/robots/compose": typeof ConsolePOrgProjectRobotsComposeRoute;
  "/p/$org/$project/simulate/create": typeof ConsolePOrgProjectSimulateCreateRoute;
  "/p/$org/$project/simulate/runs": typeof ConsolePOrgProjectSimulateRunsRoute;
  "/p/$org/$project/simulate/sessions": typeof ConsolePOrgProjectSimulateSessionsRoute;
  "/p/$org/$project/supply/orders": typeof ConsolePOrgProjectSupplyOrdersRoute;
  "/p/$org/$project/supply/shipments": typeof ConsolePOrgProjectSupplyShipmentsRoute;
  "/p/$org/$project/tasks/$taskId": typeof ConsolePOrgProjectTasksTaskIdRoute;
  "/p/$org/$project/training/compare": typeof ConsolePOrgProjectTrainingCompareRoute;
  "/p/$org/$project/work-atlas/home": typeof ConsolePOrgProjectWorkAtlasHomeRoute;
  "/p/$org/$project/work-atlas/occupations": typeof ConsolePOrgProjectWorkAtlasOccupationsRoute;
  "/p/$org/$project/work-atlas/opportunities": typeof ConsolePOrgProjectWorkAtlasOpportunitiesRoute;
  "/p/$org/$project/work-atlas/skills": typeof ConsolePOrgProjectWorkAtlasSkillsRoute;
  "/p/$org/$project/work-atlas/tasks": typeof ConsolePOrgProjectWorkAtlasTasksRoute;
  "/p/$org/$project/build-worlds": typeof ConsolePOrgProjectBuildWorldsIndexRoute;
  "/p/$org/$project/deploy": typeof ConsolePOrgProjectDeployIndexRoute;
  "/p/$org/$project/library": typeof ConsolePOrgProjectLibraryIndexRoute;
  "/p/$org/$project/loop": typeof ConsolePOrgProjectLoopIndexRoute;
  "/p/$org/$project/orders": typeof ConsolePOrgProjectOrdersIndexRoute;
  "/p/$org/$project/reports": typeof ConsolePOrgProjectReportsIndexRoute;
  "/p/$org/$project/robots": typeof ConsolePOrgProjectRobotsIndexRoute;
  "/p/$org/$project/simulate": typeof ConsolePOrgProjectSimulateIndexRoute;
  "/p/$org/$project/supply": typeof ConsolePOrgProjectSupplyIndexRoute;
  "/p/$org/$project/tasks": typeof ConsolePOrgProjectTasksIndexRoute;
  "/p/$org/$project/training": typeof ConsolePOrgProjectTrainingIndexRoute;
  "/p/$org/$project/work-atlas": typeof ConsolePOrgProjectWorkAtlasIndexRoute;
  "/p/$org/$project/build-worlds/assets/$worldId": typeof ConsolePOrgProjectBuildWorldsAssetsWorldIdRoute;
  "/p/$org/$project/build-worlds/drafts/$draftId": typeof ConsolePOrgProjectBuildWorldsDraftsDraftIdRoute;
  "/p/$org/$project/deploy/ladders/$": typeof ConsolePOrgProjectDeployLaddersSplatRoute;
  "/p/$org/$project/deploy/stations/$stationId": typeof ConsolePOrgProjectDeployStationsStationIdRoute;
  "/p/$org/$project/library/agents/$agentId": typeof ConsolePOrgProjectLibraryAgentsAgentIdRoute;
  "/p/$org/$project/library/contracts/$id": typeof ConsolePOrgProjectLibraryContractsIdRoute;
  "/p/$org/$project/library/items/$name": typeof ConsolePOrgProjectLibraryItemsNameRoute;
  "/p/$org/$project/reports/$name/changes": typeof ConsolePOrgProjectReportsNameChangesRoute;
  "/p/$org/$project/reports/$name/edit": typeof ConsolePOrgProjectReportsNameEditRoute;
  "/p/$org/$project/robots/bodies/$body": typeof ConsolePOrgProjectRobotsBodiesBodyRoute;
  "/p/$org/$project/simulate/assets/$worldId": typeof ConsolePOrgProjectSimulateAssetsWorldIdRoute;
  "/p/$org/$project/simulate/drafts/$draftId": typeof ConsolePOrgProjectSimulateDraftsDraftIdRoute;
  "/p/$org/$project/training/jobs/$jobId": typeof ConsolePOrgProjectTrainingJobsJobIdRoute;
  "/p/$org/$project/training/research/$sessionName": typeof ConsolePOrgProjectTrainingResearchSessionNameRoute;
  "/p/$org/$project/training/runs/$runId": typeof ConsolePOrgProjectTrainingRunsRunIdRoute;
  "/p/$org/$project/deploy/stations": typeof ConsolePOrgProjectDeployStationsIndexRoute;
  "/p/$org/$project/reports/$name": typeof ConsolePOrgProjectReportsNameIndexRoute;
  "/p/$org/$project/simulate/drafts": typeof ConsolePOrgProjectSimulateDraftsIndexRoute;
  "/p/$org/$project/training/research": typeof ConsolePOrgProjectTrainingResearchIndexRoute;
  "/p/$org/$project/training/runs": typeof ConsolePOrgProjectTrainingRunsIndexRoute;
  "/p/$org/$project/deploy/$robot/sessions/$session": typeof ConsolePOrgProjectDeployRobotSessionsSessionRoute;
  "/p/$org/$project/library/episodes/$sessionId/$episodeId": typeof ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRoute;
  "/p/$org/$project/loop/agent/$agentId/{-$sessionId}": typeof ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125Route;
  "/p/$org/$project/reports/$name/versions/$version": typeof ConsolePOrgProjectReportsNameVersionsVersionRoute;
  "/p/$org/$project/library/datasets/$name": typeof ConsolePOrgProjectLibraryDatasetsNameIndexRoute;
  "/p/$org/$project/library/datasets/$name/segments/$segmentId": typeof ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_console": typeof ConsoleRouteWithChildren;
  "/headset": typeof HeadsetRoute;
  "/signed-out": typeof SignedOutRoute;
  "/_console/label": typeof ConsoleLabelRouteRouteWithChildren;
  "/_console/operations": typeof ConsoleOperationsRouteRouteWithChildren;
  "/_console/production": typeof ConsoleProductionRouteRouteWithChildren;
  "/_console/settings": typeof ConsoleSettingsRouteRouteWithChildren;
  "/_console/teleoperators": typeof ConsoleTeleoperatorsRouteRouteWithChildren;
  "/_console/$": typeof ConsoleSplatRoute;
  "/_console/projects": typeof ConsoleProjectsRouteWithChildren;
  "/_console/": typeof ConsoleIndexRoute;
  "/_console/settings/platform": typeof ConsoleSettingsPlatformRouteRouteWithChildren;
  "/_console/label/admin": typeof ConsoleLabelAdminRoute;
  "/_console/label/principal": typeof ConsoleLabelPrincipalRoute;
  "/_console/label/qc": typeof ConsoleLabelQcRouteWithChildren;
  "/_console/operations/releases": typeof ConsoleOperationsReleasesRoute;
  "/_console/production/activity": typeof ConsoleProductionActivityRoute;
  "/_console/production/checks": typeof ConsoleProductionChecksRoute;
  "/_console/production/collections": typeof ConsoleProductionCollectionsRoute;
  "/_console/production/episodes": typeof ConsoleProductionEpisodesRoute;
  "/_console/production/operators": typeof ConsoleProductionOperatorsRoute;
  "/_console/production/people": typeof ConsoleProductionPeopleRoute;
  "/_console/production/pods": typeof ConsoleProductionPodsRouteWithChildren;
  "/_console/production/uploads": typeof ConsoleProductionUploadsRoute;
  "/_console/settings/billing": typeof ConsoleSettingsBillingRoute;
  "/_console/settings/keys": typeof ConsoleSettingsKeysRoute;
  "/_console/settings/operators": typeof ConsoleSettingsOperatorsRoute;
  "/_console/settings/organizations": typeof ConsoleSettingsOrganizationsRouteWithChildren;
  "/_console/settings/people": typeof ConsoleSettingsPeopleRoute;
  "/_console/settings/projects": typeof ConsoleSettingsProjectsRouteWithChildren;
  "/_console/settings/sessions": typeof ConsoleSettingsSessionsRoute;
  "/_console/supervise/$": typeof ConsoleSuperviseSplatRoute;
  "/_console/teleoperators/people": typeof ConsoleTeleoperatorsPeopleRoute;
  "/_console/teleoperators/sessions": typeof ConsoleTeleoperatorsSessionsRoute;
  "/_console/label/": typeof ConsoleLabelIndexRoute;
  "/_console/operations/": typeof ConsoleOperationsIndexRoute;
  "/_console/production/": typeof ConsoleProductionIndexRoute;
  "/_console/projects/": typeof ConsoleProjectsIndexRoute;
  "/_console/settings/": typeof ConsoleSettingsIndexRoute;
  "/_console/teleoperators/": typeof ConsoleTeleoperatorsIndexRoute;
  "/_console/label/annotate/$episodeId": typeof ConsoleLabelAnnotateEpisodeIdRoute;
  "/_console/label/audit/$episodeId": typeof ConsoleLabelAuditEpisodeIdRoute;
  "/_console/label/qc/accuracy": typeof ConsoleLabelQcAccuracyRoute;
  "/_console/p/$org/$project": typeof ConsolePOrgProjectRouteWithChildren;
  "/_console/production/collections_/$collectionId": typeof ConsoleProductionCollectionsCollectionIdRoute;
  "/_console/production/episodes_/$episodeId": typeof ConsoleProductionEpisodesEpisodeIdRoute;
  "/_console/settings/organizations/$organizationId": typeof ConsoleSettingsOrganizationsOrganizationIdRoute;
  "/_console/settings/platform/act-as": typeof ConsoleSettingsPlatformActAsRoute;
  "/_console/settings/platform/audiences": typeof ConsoleSettingsPlatformAudiencesRoute;
  "/_console/settings/platform/nodes": typeof ConsoleSettingsPlatformNodesRoute;
  "/_console/settings/platform/organizations": typeof ConsoleSettingsPlatformOrganizationsRoute;
  "/_console/settings/platform/principals": typeof ConsoleSettingsPlatformPrincipalsRoute;
  "/_console/settings/projects/$projectId": typeof ConsoleSettingsProjectsProjectIdRoute;
  "/_console/teleoperators/cockpit/$ticketId": typeof ConsoleTeleoperatorsCockpitTicketIdRoute;
  "/_console/label/audit/": typeof ConsoleLabelAuditIndexRoute;
  "/_console/label/qc/": typeof ConsoleLabelQcIndexRoute;
  "/_console/production/pods/": typeof ConsoleProductionPodsIndexRoute;
  "/_console/settings/organizations/": typeof ConsoleSettingsOrganizationsIndexRoute;
  "/_console/settings/platform/": typeof ConsoleSettingsPlatformIndexRoute;
  "/_console/settings/projects/": typeof ConsoleSettingsProjectsIndexRoute;
  "/_console/p/$org/$project/build-worlds": typeof ConsolePOrgProjectBuildWorldsRouteRouteWithChildren;
  "/_console/p/$org/$project/deploy": typeof ConsolePOrgProjectDeployRouteRouteWithChildren;
  "/_console/p/$org/$project/library": typeof ConsolePOrgProjectLibraryRouteRouteWithChildren;
  "/_console/p/$org/$project/reports": typeof ConsolePOrgProjectReportsRouteRouteWithChildren;
  "/_console/p/$org/$project/simulate": typeof ConsolePOrgProjectSimulateRouteRouteWithChildren;
  "/_console/p/$org/$project/supply": typeof ConsolePOrgProjectSupplyRouteRouteWithChildren;
  "/_console/p/$org/$project/training": typeof ConsolePOrgProjectTrainingRouteRouteWithChildren;
  "/_console/p/$org/$project/work-atlas": typeof ConsolePOrgProjectWorkAtlasRouteRouteWithChildren;
  "/_console/p/$org/$project/operations": typeof ConsolePOrgProjectOperationsRoute;
  "/_console/p/$org/$project/orders": typeof ConsolePOrgProjectOrdersRouteWithChildren;
  "/_console/p/$org/$project/settings": typeof ConsolePOrgProjectSettingsRoute;
  "/_console/p/$org/$project/tasks": typeof ConsolePOrgProjectTasksRouteWithChildren;
  "/_console/production/pods_/$podId/$episodeId": typeof ConsoleProductionPodsPodIdEpisodeIdRoute;
  "/_console/settings/organizations/$organizationId_/billing": typeof ConsoleSettingsOrganizationsOrganizationIdBillingRoute;
  "/_console/p/$org/$project/": typeof ConsolePOrgProjectIndexRoute;
  "/_console/production/pods/$podId/": typeof ConsoleProductionPodsPodIdIndexRoute;
  "/_console/p/$org/$project/build-worlds/assets": typeof ConsolePOrgProjectBuildWorldsAssetsRouteWithChildren;
  "/_console/p/$org/$project/build-worlds/create": typeof ConsolePOrgProjectBuildWorldsCreateRoute;
  "/_console/p/$org/$project/deploy/$robot": typeof ConsolePOrgProjectDeployRobotRoute;
  "/_console/p/$org/$project/deploy/stations": typeof ConsolePOrgProjectDeployStationsRouteWithChildren;
  "/_console/p/$org/$project/library/issues": typeof ConsolePOrgProjectLibraryIssuesRoute;
  "/_console/p/$org/$project/library/map": typeof ConsolePOrgProjectLibraryMapRoute;
  "/_console/p/$org/$project/library/search": typeof ConsolePOrgProjectLibrarySearchRoute;
  "/_console/p/$org/$project/library/semantic": typeof ConsolePOrgProjectLibrarySemanticRoute;
  "/_console/p/$org/$project/loop/board": typeof ConsolePOrgProjectLoopBoardRoute;
  "/_console/p/$org/$project/loop/manager": typeof ConsolePOrgProjectLoopManagerRoute;
  "/_console/p/$org/$project/loop/team": typeof ConsolePOrgProjectLoopTeamRoute;
  "/_console/p/$org/$project/reports/model": typeof ConsolePOrgProjectReportsModelRoute;
  "/_console/p/$org/$project/reports/new": typeof ConsolePOrgProjectReportsNewRoute;
  "/_console/p/$org/$project/robots/compose": typeof ConsolePOrgProjectRobotsComposeRoute;
  "/_console/p/$org/$project/simulate/create": typeof ConsolePOrgProjectSimulateCreateRoute;
  "/_console/p/$org/$project/simulate/runs": typeof ConsolePOrgProjectSimulateRunsRoute;
  "/_console/p/$org/$project/simulate/sessions": typeof ConsolePOrgProjectSimulateSessionsRoute;
  "/_console/p/$org/$project/supply/orders": typeof ConsolePOrgProjectSupplyOrdersRoute;
  "/_console/p/$org/$project/supply/shipments": typeof ConsolePOrgProjectSupplyShipmentsRoute;
  "/_console/p/$org/$project/tasks/$taskId": typeof ConsolePOrgProjectTasksTaskIdRoute;
  "/_console/p/$org/$project/training/compare": typeof ConsolePOrgProjectTrainingCompareRoute;
  "/_console/p/$org/$project/work-atlas/home": typeof ConsolePOrgProjectWorkAtlasHomeRoute;
  "/_console/p/$org/$project/work-atlas/occupations": typeof ConsolePOrgProjectWorkAtlasOccupationsRoute;
  "/_console/p/$org/$project/work-atlas/opportunities": typeof ConsolePOrgProjectWorkAtlasOpportunitiesRoute;
  "/_console/p/$org/$project/work-atlas/skills": typeof ConsolePOrgProjectWorkAtlasSkillsRoute;
  "/_console/p/$org/$project/work-atlas/tasks": typeof ConsolePOrgProjectWorkAtlasTasksRoute;
  "/_console/p/$org/$project/build-worlds/": typeof ConsolePOrgProjectBuildWorldsIndexRoute;
  "/_console/p/$org/$project/deploy/": typeof ConsolePOrgProjectDeployIndexRoute;
  "/_console/p/$org/$project/library/": typeof ConsolePOrgProjectLibraryIndexRoute;
  "/_console/p/$org/$project/loop/": typeof ConsolePOrgProjectLoopIndexRoute;
  "/_console/p/$org/$project/orders/": typeof ConsolePOrgProjectOrdersIndexRoute;
  "/_console/p/$org/$project/reports/": typeof ConsolePOrgProjectReportsIndexRoute;
  "/_console/p/$org/$project/robots/": typeof ConsolePOrgProjectRobotsIndexRoute;
  "/_console/p/$org/$project/simulate/": typeof ConsolePOrgProjectSimulateIndexRoute;
  "/_console/p/$org/$project/supply/": typeof ConsolePOrgProjectSupplyIndexRoute;
  "/_console/p/$org/$project/tasks/": typeof ConsolePOrgProjectTasksIndexRoute;
  "/_console/p/$org/$project/training/": typeof ConsolePOrgProjectTrainingIndexRoute;
  "/_console/p/$org/$project/work-atlas/": typeof ConsolePOrgProjectWorkAtlasIndexRoute;
  "/_console/p/$org/$project/build-worlds/assets/$worldId": typeof ConsolePOrgProjectBuildWorldsAssetsWorldIdRoute;
  "/_console/p/$org/$project/build-worlds/drafts/$draftId": typeof ConsolePOrgProjectBuildWorldsDraftsDraftIdRoute;
  "/_console/p/$org/$project/deploy/ladders/$": typeof ConsolePOrgProjectDeployLaddersSplatRoute;
  "/_console/p/$org/$project/deploy/stations/$stationId": typeof ConsolePOrgProjectDeployStationsStationIdRoute;
  "/_console/p/$org/$project/library/agents/$agentId": typeof ConsolePOrgProjectLibraryAgentsAgentIdRoute;
  "/_console/p/$org/$project/library/contracts/$id": typeof ConsolePOrgProjectLibraryContractsIdRoute;
  "/_console/p/$org/$project/library/items/$name": typeof ConsolePOrgProjectLibraryItemsNameRoute;
  "/_console/p/$org/$project/reports/$name/changes": typeof ConsolePOrgProjectReportsNameChangesRoute;
  "/_console/p/$org/$project/reports/$name/edit": typeof ConsolePOrgProjectReportsNameEditRoute;
  "/_console/p/$org/$project/robots/bodies/$body": typeof ConsolePOrgProjectRobotsBodiesBodyRoute;
  "/_console/p/$org/$project/simulate/assets/$worldId": typeof ConsolePOrgProjectSimulateAssetsWorldIdRoute;
  "/_console/p/$org/$project/simulate/drafts/$draftId": typeof ConsolePOrgProjectSimulateDraftsDraftIdRoute;
  "/_console/p/$org/$project/training/jobs/$jobId": typeof ConsolePOrgProjectTrainingJobsJobIdRoute;
  "/_console/p/$org/$project/training/research/$sessionName": typeof ConsolePOrgProjectTrainingResearchSessionNameRoute;
  "/_console/p/$org/$project/training/runs/$runId": typeof ConsolePOrgProjectTrainingRunsRunIdRoute;
  "/_console/p/$org/$project/deploy/stations/": typeof ConsolePOrgProjectDeployStationsIndexRoute;
  "/_console/p/$org/$project/reports/$name/": typeof ConsolePOrgProjectReportsNameIndexRoute;
  "/_console/p/$org/$project/simulate/drafts/": typeof ConsolePOrgProjectSimulateDraftsIndexRoute;
  "/_console/p/$org/$project/training/research/": typeof ConsolePOrgProjectTrainingResearchIndexRoute;
  "/_console/p/$org/$project/training/runs/": typeof ConsolePOrgProjectTrainingRunsIndexRoute;
  "/_console/p/$org/$project/deploy/$robot_/sessions/$session": typeof ConsolePOrgProjectDeployRobotSessionsSessionRoute;
  "/_console/p/$org/$project/library/episodes/$sessionId/$episodeId": typeof ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRoute;
  "/_console/p/$org/$project/loop/agent/$agentId/{-$sessionId}": typeof ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125Route;
  "/_console/p/$org/$project/reports/$name/versions/$version": typeof ConsolePOrgProjectReportsNameVersionsVersionRoute;
  "/_console/p/$org/$project/library/datasets/$name/": typeof ConsolePOrgProjectLibraryDatasetsNameIndexRoute;
  "/_console/p/$org/$project/library/datasets/$name/segments/$segmentId": typeof ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/headset"
    | "/signed-out"
    | "/label"
    | "/operations"
    | "/production"
    | "/settings"
    | "/teleoperators"
    | "/$"
    | "/projects"
    | "/settings/platform"
    | "/label/admin"
    | "/label/principal"
    | "/label/qc"
    | "/operations/releases"
    | "/production/activity"
    | "/production/checks"
    | "/production/collections"
    | "/production/episodes"
    | "/production/operators"
    | "/production/people"
    | "/production/pods"
    | "/production/uploads"
    | "/settings/billing"
    | "/settings/keys"
    | "/settings/operators"
    | "/settings/organizations"
    | "/settings/people"
    | "/settings/projects"
    | "/settings/sessions"
    | "/supervise/$"
    | "/teleoperators/people"
    | "/teleoperators/sessions"
    | "/label/"
    | "/operations/"
    | "/production/"
    | "/projects/"
    | "/settings/"
    | "/teleoperators/"
    | "/label/annotate/$episodeId"
    | "/label/audit/$episodeId"
    | "/label/qc/accuracy"
    | "/p/$org/$project"
    | "/production/collections/$collectionId"
    | "/production/episodes/$episodeId"
    | "/settings/organizations/$organizationId"
    | "/settings/platform/act-as"
    | "/settings/platform/audiences"
    | "/settings/platform/nodes"
    | "/settings/platform/organizations"
    | "/settings/platform/principals"
    | "/settings/projects/$projectId"
    | "/teleoperators/cockpit/$ticketId"
    | "/label/audit/"
    | "/label/qc/"
    | "/production/pods/"
    | "/settings/organizations/"
    | "/settings/platform/"
    | "/settings/projects/"
    | "/p/$org/$project/build-worlds"
    | "/p/$org/$project/deploy"
    | "/p/$org/$project/library"
    | "/p/$org/$project/reports"
    | "/p/$org/$project/simulate"
    | "/p/$org/$project/supply"
    | "/p/$org/$project/training"
    | "/p/$org/$project/work-atlas"
    | "/p/$org/$project/operations"
    | "/p/$org/$project/orders"
    | "/p/$org/$project/settings"
    | "/p/$org/$project/tasks"
    | "/production/pods/$podId/$episodeId"
    | "/settings/organizations/$organizationId/billing"
    | "/p/$org/$project/"
    | "/production/pods/$podId/"
    | "/p/$org/$project/build-worlds/assets"
    | "/p/$org/$project/build-worlds/create"
    | "/p/$org/$project/deploy/$robot"
    | "/p/$org/$project/deploy/stations"
    | "/p/$org/$project/library/issues"
    | "/p/$org/$project/library/map"
    | "/p/$org/$project/library/search"
    | "/p/$org/$project/library/semantic"
    | "/p/$org/$project/loop/board"
    | "/p/$org/$project/loop/manager"
    | "/p/$org/$project/loop/team"
    | "/p/$org/$project/reports/model"
    | "/p/$org/$project/reports/new"
    | "/p/$org/$project/robots/compose"
    | "/p/$org/$project/simulate/create"
    | "/p/$org/$project/simulate/runs"
    | "/p/$org/$project/simulate/sessions"
    | "/p/$org/$project/supply/orders"
    | "/p/$org/$project/supply/shipments"
    | "/p/$org/$project/tasks/$taskId"
    | "/p/$org/$project/training/compare"
    | "/p/$org/$project/work-atlas/home"
    | "/p/$org/$project/work-atlas/occupations"
    | "/p/$org/$project/work-atlas/opportunities"
    | "/p/$org/$project/work-atlas/skills"
    | "/p/$org/$project/work-atlas/tasks"
    | "/p/$org/$project/build-worlds/"
    | "/p/$org/$project/deploy/"
    | "/p/$org/$project/library/"
    | "/p/$org/$project/loop/"
    | "/p/$org/$project/orders/"
    | "/p/$org/$project/reports/"
    | "/p/$org/$project/robots/"
    | "/p/$org/$project/simulate/"
    | "/p/$org/$project/supply/"
    | "/p/$org/$project/tasks/"
    | "/p/$org/$project/training/"
    | "/p/$org/$project/work-atlas/"
    | "/p/$org/$project/build-worlds/assets/$worldId"
    | "/p/$org/$project/build-worlds/drafts/$draftId"
    | "/p/$org/$project/deploy/ladders/$"
    | "/p/$org/$project/deploy/stations/$stationId"
    | "/p/$org/$project/library/agents/$agentId"
    | "/p/$org/$project/library/contracts/$id"
    | "/p/$org/$project/library/items/$name"
    | "/p/$org/$project/reports/$name/changes"
    | "/p/$org/$project/reports/$name/edit"
    | "/p/$org/$project/robots/bodies/$body"
    | "/p/$org/$project/simulate/assets/$worldId"
    | "/p/$org/$project/simulate/drafts/$draftId"
    | "/p/$org/$project/training/jobs/$jobId"
    | "/p/$org/$project/training/research/$sessionName"
    | "/p/$org/$project/training/runs/$runId"
    | "/p/$org/$project/deploy/stations/"
    | "/p/$org/$project/reports/$name/"
    | "/p/$org/$project/simulate/drafts/"
    | "/p/$org/$project/training/research/"
    | "/p/$org/$project/training/runs/"
    | "/p/$org/$project/deploy/$robot/sessions/$session"
    | "/p/$org/$project/library/episodes/$sessionId/$episodeId"
    | "/p/$org/$project/loop/agent/$agentId/{-$sessionId}"
    | "/p/$org/$project/reports/$name/versions/$version"
    | "/p/$org/$project/library/datasets/$name/"
    | "/p/$org/$project/library/datasets/$name/segments/$segmentId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/headset"
    | "/signed-out"
    | "/$"
    | "/"
    | "/label/admin"
    | "/label/principal"
    | "/operations/releases"
    | "/production/activity"
    | "/production/checks"
    | "/production/collections"
    | "/production/episodes"
    | "/production/operators"
    | "/production/people"
    | "/production/uploads"
    | "/settings/billing"
    | "/settings/keys"
    | "/settings/operators"
    | "/settings/people"
    | "/settings/sessions"
    | "/supervise/$"
    | "/teleoperators/people"
    | "/teleoperators/sessions"
    | "/label"
    | "/operations"
    | "/production"
    | "/projects"
    | "/settings"
    | "/teleoperators"
    | "/label/annotate/$episodeId"
    | "/label/audit/$episodeId"
    | "/label/qc/accuracy"
    | "/production/collections/$collectionId"
    | "/production/episodes/$episodeId"
    | "/settings/organizations/$organizationId"
    | "/settings/platform/act-as"
    | "/settings/platform/audiences"
    | "/settings/platform/nodes"
    | "/settings/platform/organizations"
    | "/settings/platform/principals"
    | "/settings/projects/$projectId"
    | "/teleoperators/cockpit/$ticketId"
    | "/label/audit"
    | "/label/qc"
    | "/production/pods"
    | "/settings/organizations"
    | "/settings/platform"
    | "/settings/projects"
    | "/p/$org/$project/operations"
    | "/p/$org/$project/settings"
    | "/production/pods/$podId/$episodeId"
    | "/settings/organizations/$organizationId/billing"
    | "/p/$org/$project"
    | "/production/pods/$podId"
    | "/p/$org/$project/build-worlds/assets"
    | "/p/$org/$project/build-worlds/create"
    | "/p/$org/$project/deploy/$robot"
    | "/p/$org/$project/library/issues"
    | "/p/$org/$project/library/map"
    | "/p/$org/$project/library/search"
    | "/p/$org/$project/library/semantic"
    | "/p/$org/$project/loop/board"
    | "/p/$org/$project/loop/manager"
    | "/p/$org/$project/loop/team"
    | "/p/$org/$project/reports/model"
    | "/p/$org/$project/reports/new"
    | "/p/$org/$project/robots/compose"
    | "/p/$org/$project/simulate/create"
    | "/p/$org/$project/simulate/runs"
    | "/p/$org/$project/simulate/sessions"
    | "/p/$org/$project/supply/orders"
    | "/p/$org/$project/supply/shipments"
    | "/p/$org/$project/tasks/$taskId"
    | "/p/$org/$project/training/compare"
    | "/p/$org/$project/work-atlas/home"
    | "/p/$org/$project/work-atlas/occupations"
    | "/p/$org/$project/work-atlas/opportunities"
    | "/p/$org/$project/work-atlas/skills"
    | "/p/$org/$project/work-atlas/tasks"
    | "/p/$org/$project/build-worlds"
    | "/p/$org/$project/deploy"
    | "/p/$org/$project/library"
    | "/p/$org/$project/loop"
    | "/p/$org/$project/orders"
    | "/p/$org/$project/reports"
    | "/p/$org/$project/robots"
    | "/p/$org/$project/simulate"
    | "/p/$org/$project/supply"
    | "/p/$org/$project/tasks"
    | "/p/$org/$project/training"
    | "/p/$org/$project/work-atlas"
    | "/p/$org/$project/build-worlds/assets/$worldId"
    | "/p/$org/$project/build-worlds/drafts/$draftId"
    | "/p/$org/$project/deploy/ladders/$"
    | "/p/$org/$project/deploy/stations/$stationId"
    | "/p/$org/$project/library/agents/$agentId"
    | "/p/$org/$project/library/contracts/$id"
    | "/p/$org/$project/library/items/$name"
    | "/p/$org/$project/reports/$name/changes"
    | "/p/$org/$project/reports/$name/edit"
    | "/p/$org/$project/robots/bodies/$body"
    | "/p/$org/$project/simulate/assets/$worldId"
    | "/p/$org/$project/simulate/drafts/$draftId"
    | "/p/$org/$project/training/jobs/$jobId"
    | "/p/$org/$project/training/research/$sessionName"
    | "/p/$org/$project/training/runs/$runId"
    | "/p/$org/$project/deploy/stations"
    | "/p/$org/$project/reports/$name"
    | "/p/$org/$project/simulate/drafts"
    | "/p/$org/$project/training/research"
    | "/p/$org/$project/training/runs"
    | "/p/$org/$project/deploy/$robot/sessions/$session"
    | "/p/$org/$project/library/episodes/$sessionId/$episodeId"
    | "/p/$org/$project/loop/agent/$agentId/{-$sessionId}"
    | "/p/$org/$project/reports/$name/versions/$version"
    | "/p/$org/$project/library/datasets/$name"
    | "/p/$org/$project/library/datasets/$name/segments/$segmentId";
  id:
    | "__root__"
    | "/_console"
    | "/headset"
    | "/signed-out"
    | "/_console/label"
    | "/_console/operations"
    | "/_console/production"
    | "/_console/settings"
    | "/_console/teleoperators"
    | "/_console/$"
    | "/_console/projects"
    | "/_console/"
    | "/_console/settings/platform"
    | "/_console/label/admin"
    | "/_console/label/principal"
    | "/_console/label/qc"
    | "/_console/operations/releases"
    | "/_console/production/activity"
    | "/_console/production/checks"
    | "/_console/production/collections"
    | "/_console/production/episodes"
    | "/_console/production/operators"
    | "/_console/production/people"
    | "/_console/production/pods"
    | "/_console/production/uploads"
    | "/_console/settings/billing"
    | "/_console/settings/keys"
    | "/_console/settings/operators"
    | "/_console/settings/organizations"
    | "/_console/settings/people"
    | "/_console/settings/projects"
    | "/_console/settings/sessions"
    | "/_console/supervise/$"
    | "/_console/teleoperators/people"
    | "/_console/teleoperators/sessions"
    | "/_console/label/"
    | "/_console/operations/"
    | "/_console/production/"
    | "/_console/projects/"
    | "/_console/settings/"
    | "/_console/teleoperators/"
    | "/_console/label/annotate/$episodeId"
    | "/_console/label/audit/$episodeId"
    | "/_console/label/qc/accuracy"
    | "/_console/p/$org/$project"
    | "/_console/production/collections_/$collectionId"
    | "/_console/production/episodes_/$episodeId"
    | "/_console/settings/organizations/$organizationId"
    | "/_console/settings/platform/act-as"
    | "/_console/settings/platform/audiences"
    | "/_console/settings/platform/nodes"
    | "/_console/settings/platform/organizations"
    | "/_console/settings/platform/principals"
    | "/_console/settings/projects/$projectId"
    | "/_console/teleoperators/cockpit/$ticketId"
    | "/_console/label/audit/"
    | "/_console/label/qc/"
    | "/_console/production/pods/"
    | "/_console/settings/organizations/"
    | "/_console/settings/platform/"
    | "/_console/settings/projects/"
    | "/_console/p/$org/$project/build-worlds"
    | "/_console/p/$org/$project/deploy"
    | "/_console/p/$org/$project/library"
    | "/_console/p/$org/$project/reports"
    | "/_console/p/$org/$project/simulate"
    | "/_console/p/$org/$project/supply"
    | "/_console/p/$org/$project/training"
    | "/_console/p/$org/$project/work-atlas"
    | "/_console/p/$org/$project/operations"
    | "/_console/p/$org/$project/orders"
    | "/_console/p/$org/$project/settings"
    | "/_console/p/$org/$project/tasks"
    | "/_console/production/pods_/$podId/$episodeId"
    | "/_console/settings/organizations/$organizationId_/billing"
    | "/_console/p/$org/$project/"
    | "/_console/production/pods/$podId/"
    | "/_console/p/$org/$project/build-worlds/assets"
    | "/_console/p/$org/$project/build-worlds/create"
    | "/_console/p/$org/$project/deploy/$robot"
    | "/_console/p/$org/$project/deploy/stations"
    | "/_console/p/$org/$project/library/issues"
    | "/_console/p/$org/$project/library/map"
    | "/_console/p/$org/$project/library/search"
    | "/_console/p/$org/$project/library/semantic"
    | "/_console/p/$org/$project/loop/board"
    | "/_console/p/$org/$project/loop/manager"
    | "/_console/p/$org/$project/loop/team"
    | "/_console/p/$org/$project/reports/model"
    | "/_console/p/$org/$project/reports/new"
    | "/_console/p/$org/$project/robots/compose"
    | "/_console/p/$org/$project/simulate/create"
    | "/_console/p/$org/$project/simulate/runs"
    | "/_console/p/$org/$project/simulate/sessions"
    | "/_console/p/$org/$project/supply/orders"
    | "/_console/p/$org/$project/supply/shipments"
    | "/_console/p/$org/$project/tasks/$taskId"
    | "/_console/p/$org/$project/training/compare"
    | "/_console/p/$org/$project/work-atlas/home"
    | "/_console/p/$org/$project/work-atlas/occupations"
    | "/_console/p/$org/$project/work-atlas/opportunities"
    | "/_console/p/$org/$project/work-atlas/skills"
    | "/_console/p/$org/$project/work-atlas/tasks"
    | "/_console/p/$org/$project/build-worlds/"
    | "/_console/p/$org/$project/deploy/"
    | "/_console/p/$org/$project/library/"
    | "/_console/p/$org/$project/loop/"
    | "/_console/p/$org/$project/orders/"
    | "/_console/p/$org/$project/reports/"
    | "/_console/p/$org/$project/robots/"
    | "/_console/p/$org/$project/simulate/"
    | "/_console/p/$org/$project/supply/"
    | "/_console/p/$org/$project/tasks/"
    | "/_console/p/$org/$project/training/"
    | "/_console/p/$org/$project/work-atlas/"
    | "/_console/p/$org/$project/build-worlds/assets/$worldId"
    | "/_console/p/$org/$project/build-worlds/drafts/$draftId"
    | "/_console/p/$org/$project/deploy/ladders/$"
    | "/_console/p/$org/$project/deploy/stations/$stationId"
    | "/_console/p/$org/$project/library/agents/$agentId"
    | "/_console/p/$org/$project/library/contracts/$id"
    | "/_console/p/$org/$project/library/items/$name"
    | "/_console/p/$org/$project/reports/$name/changes"
    | "/_console/p/$org/$project/reports/$name/edit"
    | "/_console/p/$org/$project/robots/bodies/$body"
    | "/_console/p/$org/$project/simulate/assets/$worldId"
    | "/_console/p/$org/$project/simulate/drafts/$draftId"
    | "/_console/p/$org/$project/training/jobs/$jobId"
    | "/_console/p/$org/$project/training/research/$sessionName"
    | "/_console/p/$org/$project/training/runs/$runId"
    | "/_console/p/$org/$project/deploy/stations/"
    | "/_console/p/$org/$project/reports/$name/"
    | "/_console/p/$org/$project/simulate/drafts/"
    | "/_console/p/$org/$project/training/research/"
    | "/_console/p/$org/$project/training/runs/"
    | "/_console/p/$org/$project/deploy/$robot_/sessions/$session"
    | "/_console/p/$org/$project/library/episodes/$sessionId/$episodeId"
    | "/_console/p/$org/$project/loop/agent/$agentId/{-$sessionId}"
    | "/_console/p/$org/$project/reports/$name/versions/$version"
    | "/_console/p/$org/$project/library/datasets/$name/"
    | "/_console/p/$org/$project/library/datasets/$name/segments/$segmentId";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  ConsoleRoute: typeof ConsoleRouteWithChildren;
  HeadsetRoute: typeof HeadsetRoute;
  SignedOutRoute: typeof SignedOutRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_console": {
      id: "/_console";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof ConsoleRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/headset": {
      id: "/headset";
      path: "/headset";
      fullPath: "/headset";
      preLoaderRoute: typeof HeadsetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signed-out": {
      id: "/signed-out";
      path: "/signed-out";
      fullPath: "/signed-out";
      preLoaderRoute: typeof SignedOutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_console/": {
      id: "/_console/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof ConsoleIndexRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/_console/$": {
      id: "/_console/$";
      path: "/$";
      fullPath: "/$";
      preLoaderRoute: typeof ConsoleSplatRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/_console/label": {
      id: "/_console/label";
      path: "/label";
      fullPath: "/label";
      preLoaderRoute: typeof ConsoleLabelRouteRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/_console/operations": {
      id: "/_console/operations";
      path: "/operations";
      fullPath: "/operations";
      preLoaderRoute: typeof ConsoleOperationsRouteRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/_console/production": {
      id: "/_console/production";
      path: "/production";
      fullPath: "/production";
      preLoaderRoute: typeof ConsoleProductionRouteRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/_console/projects": {
      id: "/_console/projects";
      path: "/projects";
      fullPath: "/projects";
      preLoaderRoute: typeof ConsoleProjectsRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/_console/settings": {
      id: "/_console/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof ConsoleSettingsRouteRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/_console/teleoperators": {
      id: "/_console/teleoperators";
      path: "/teleoperators";
      fullPath: "/teleoperators";
      preLoaderRoute: typeof ConsoleTeleoperatorsRouteRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/_console/label/": {
      id: "/_console/label/";
      path: "/";
      fullPath: "/label/";
      preLoaderRoute: typeof ConsoleLabelIndexRouteImport;
      parentRoute: typeof ConsoleLabelRouteRoute;
    };
    "/_console/label/admin": {
      id: "/_console/label/admin";
      path: "/admin";
      fullPath: "/label/admin";
      preLoaderRoute: typeof ConsoleLabelAdminRouteImport;
      parentRoute: typeof ConsoleLabelRouteRoute;
    };
    "/_console/label/principal": {
      id: "/_console/label/principal";
      path: "/principal";
      fullPath: "/label/principal";
      preLoaderRoute: typeof ConsoleLabelPrincipalRouteImport;
      parentRoute: typeof ConsoleLabelRouteRoute;
    };
    "/_console/label/qc": {
      id: "/_console/label/qc";
      path: "/qc";
      fullPath: "/label/qc";
      preLoaderRoute: typeof ConsoleLabelQcRouteImport;
      parentRoute: typeof ConsoleLabelRouteRoute;
    };
    "/_console/operations/": {
      id: "/_console/operations/";
      path: "/";
      fullPath: "/operations/";
      preLoaderRoute: typeof ConsoleOperationsIndexRouteImport;
      parentRoute: typeof ConsoleOperationsRouteRoute;
    };
    "/_console/operations/releases": {
      id: "/_console/operations/releases";
      path: "/releases";
      fullPath: "/operations/releases";
      preLoaderRoute: typeof ConsoleOperationsReleasesRouteImport;
      parentRoute: typeof ConsoleOperationsRouteRoute;
    };
    "/_console/production/": {
      id: "/_console/production/";
      path: "/";
      fullPath: "/production/";
      preLoaderRoute: typeof ConsoleProductionIndexRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/production/activity": {
      id: "/_console/production/activity";
      path: "/activity";
      fullPath: "/production/activity";
      preLoaderRoute: typeof ConsoleProductionActivityRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/production/checks": {
      id: "/_console/production/checks";
      path: "/checks";
      fullPath: "/production/checks";
      preLoaderRoute: typeof ConsoleProductionChecksRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/production/collections": {
      id: "/_console/production/collections";
      path: "/collections";
      fullPath: "/production/collections";
      preLoaderRoute: typeof ConsoleProductionCollectionsRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/production/episodes": {
      id: "/_console/production/episodes";
      path: "/episodes";
      fullPath: "/production/episodes";
      preLoaderRoute: typeof ConsoleProductionEpisodesRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/production/operators": {
      id: "/_console/production/operators";
      path: "/operators";
      fullPath: "/production/operators";
      preLoaderRoute: typeof ConsoleProductionOperatorsRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/production/people": {
      id: "/_console/production/people";
      path: "/people";
      fullPath: "/production/people";
      preLoaderRoute: typeof ConsoleProductionPeopleRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/production/pods": {
      id: "/_console/production/pods";
      path: "/pods";
      fullPath: "/production/pods";
      preLoaderRoute: typeof ConsoleProductionPodsRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/production/uploads": {
      id: "/_console/production/uploads";
      path: "/uploads";
      fullPath: "/production/uploads";
      preLoaderRoute: typeof ConsoleProductionUploadsRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/projects/": {
      id: "/_console/projects/";
      path: "/";
      fullPath: "/projects/";
      preLoaderRoute: typeof ConsoleProjectsIndexRouteImport;
      parentRoute: typeof ConsoleProjectsRoute;
    };
    "/_console/settings/": {
      id: "/_console/settings/";
      path: "/";
      fullPath: "/settings/";
      preLoaderRoute: typeof ConsoleSettingsIndexRouteImport;
      parentRoute: typeof ConsoleSettingsRouteRoute;
    };
    "/_console/settings/billing": {
      id: "/_console/settings/billing";
      path: "/billing";
      fullPath: "/settings/billing";
      preLoaderRoute: typeof ConsoleSettingsBillingRouteImport;
      parentRoute: typeof ConsoleSettingsRouteRoute;
    };
    "/_console/settings/keys": {
      id: "/_console/settings/keys";
      path: "/keys";
      fullPath: "/settings/keys";
      preLoaderRoute: typeof ConsoleSettingsKeysRouteImport;
      parentRoute: typeof ConsoleSettingsRouteRoute;
    };
    "/_console/settings/operators": {
      id: "/_console/settings/operators";
      path: "/operators";
      fullPath: "/settings/operators";
      preLoaderRoute: typeof ConsoleSettingsOperatorsRouteImport;
      parentRoute: typeof ConsoleSettingsRouteRoute;
    };
    "/_console/settings/organizations": {
      id: "/_console/settings/organizations";
      path: "/organizations";
      fullPath: "/settings/organizations";
      preLoaderRoute: typeof ConsoleSettingsOrganizationsRouteImport;
      parentRoute: typeof ConsoleSettingsRouteRoute;
    };
    "/_console/settings/people": {
      id: "/_console/settings/people";
      path: "/people";
      fullPath: "/settings/people";
      preLoaderRoute: typeof ConsoleSettingsPeopleRouteImport;
      parentRoute: typeof ConsoleSettingsRouteRoute;
    };
    "/_console/settings/platform": {
      id: "/_console/settings/platform";
      path: "/platform";
      fullPath: "/settings/platform";
      preLoaderRoute: typeof ConsoleSettingsPlatformRouteRouteImport;
      parentRoute: typeof ConsoleSettingsRouteRoute;
    };
    "/_console/settings/projects": {
      id: "/_console/settings/projects";
      path: "/projects";
      fullPath: "/settings/projects";
      preLoaderRoute: typeof ConsoleSettingsProjectsRouteImport;
      parentRoute: typeof ConsoleSettingsRouteRoute;
    };
    "/_console/settings/sessions": {
      id: "/_console/settings/sessions";
      path: "/sessions";
      fullPath: "/settings/sessions";
      preLoaderRoute: typeof ConsoleSettingsSessionsRouteImport;
      parentRoute: typeof ConsoleSettingsRouteRoute;
    };
    "/_console/supervise/$": {
      id: "/_console/supervise/$";
      path: "/supervise/$";
      fullPath: "/supervise/$";
      preLoaderRoute: typeof ConsoleSuperviseSplatRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/_console/teleoperators/": {
      id: "/_console/teleoperators/";
      path: "/";
      fullPath: "/teleoperators/";
      preLoaderRoute: typeof ConsoleTeleoperatorsIndexRouteImport;
      parentRoute: typeof ConsoleTeleoperatorsRouteRoute;
    };
    "/_console/teleoperators/people": {
      id: "/_console/teleoperators/people";
      path: "/people";
      fullPath: "/teleoperators/people";
      preLoaderRoute: typeof ConsoleTeleoperatorsPeopleRouteImport;
      parentRoute: typeof ConsoleTeleoperatorsRouteRoute;
    };
    "/_console/teleoperators/sessions": {
      id: "/_console/teleoperators/sessions";
      path: "/sessions";
      fullPath: "/teleoperators/sessions";
      preLoaderRoute: typeof ConsoleTeleoperatorsSessionsRouteImport;
      parentRoute: typeof ConsoleTeleoperatorsRouteRoute;
    };
    "/_console/label/annotate/$episodeId": {
      id: "/_console/label/annotate/$episodeId";
      path: "/annotate/$episodeId";
      fullPath: "/label/annotate/$episodeId";
      preLoaderRoute: typeof ConsoleLabelAnnotateEpisodeIdRouteImport;
      parentRoute: typeof ConsoleLabelRouteRoute;
    };
    "/_console/label/audit/": {
      id: "/_console/label/audit/";
      path: "/audit";
      fullPath: "/label/audit/";
      preLoaderRoute: typeof ConsoleLabelAuditIndexRouteImport;
      parentRoute: typeof ConsoleLabelRouteRoute;
    };
    "/_console/label/audit/$episodeId": {
      id: "/_console/label/audit/$episodeId";
      path: "/audit/$episodeId";
      fullPath: "/label/audit/$episodeId";
      preLoaderRoute: typeof ConsoleLabelAuditEpisodeIdRouteImport;
      parentRoute: typeof ConsoleLabelRouteRoute;
    };
    "/_console/label/qc/": {
      id: "/_console/label/qc/";
      path: "/";
      fullPath: "/label/qc/";
      preLoaderRoute: typeof ConsoleLabelQcIndexRouteImport;
      parentRoute: typeof ConsoleLabelQcRoute;
    };
    "/_console/label/qc/accuracy": {
      id: "/_console/label/qc/accuracy";
      path: "/accuracy";
      fullPath: "/label/qc/accuracy";
      preLoaderRoute: typeof ConsoleLabelQcAccuracyRouteImport;
      parentRoute: typeof ConsoleLabelQcRoute;
    };
    "/_console/p/$org/$project": {
      id: "/_console/p/$org/$project";
      path: "/p/$org/$project";
      fullPath: "/p/$org/$project";
      preLoaderRoute: typeof ConsolePOrgProjectRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/_console/production/collections_/$collectionId": {
      id: "/_console/production/collections_/$collectionId";
      path: "/collections/$collectionId";
      fullPath: "/production/collections/$collectionId";
      preLoaderRoute: typeof ConsoleProductionCollectionsCollectionIdRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/production/episodes_/$episodeId": {
      id: "/_console/production/episodes_/$episodeId";
      path: "/episodes/$episodeId";
      fullPath: "/production/episodes/$episodeId";
      preLoaderRoute: typeof ConsoleProductionEpisodesEpisodeIdRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/production/pods/": {
      id: "/_console/production/pods/";
      path: "/";
      fullPath: "/production/pods/";
      preLoaderRoute: typeof ConsoleProductionPodsIndexRouteImport;
      parentRoute: typeof ConsoleProductionPodsRoute;
    };
    "/_console/settings/organizations/": {
      id: "/_console/settings/organizations/";
      path: "/";
      fullPath: "/settings/organizations/";
      preLoaderRoute: typeof ConsoleSettingsOrganizationsIndexRouteImport;
      parentRoute: typeof ConsoleSettingsOrganizationsRoute;
    };
    "/_console/settings/organizations/$organizationId": {
      id: "/_console/settings/organizations/$organizationId";
      path: "/$organizationId";
      fullPath: "/settings/organizations/$organizationId";
      preLoaderRoute: typeof ConsoleSettingsOrganizationsOrganizationIdRouteImport;
      parentRoute: typeof ConsoleSettingsOrganizationsRoute;
    };
    "/_console/settings/platform/": {
      id: "/_console/settings/platform/";
      path: "/";
      fullPath: "/settings/platform/";
      preLoaderRoute: typeof ConsoleSettingsPlatformIndexRouteImport;
      parentRoute: typeof ConsoleSettingsPlatformRouteRoute;
    };
    "/_console/settings/platform/act-as": {
      id: "/_console/settings/platform/act-as";
      path: "/act-as";
      fullPath: "/settings/platform/act-as";
      preLoaderRoute: typeof ConsoleSettingsPlatformActAsRouteImport;
      parentRoute: typeof ConsoleSettingsPlatformRouteRoute;
    };
    "/_console/settings/platform/audiences": {
      id: "/_console/settings/platform/audiences";
      path: "/audiences";
      fullPath: "/settings/platform/audiences";
      preLoaderRoute: typeof ConsoleSettingsPlatformAudiencesRouteImport;
      parentRoute: typeof ConsoleSettingsPlatformRouteRoute;
    };
    "/_console/settings/platform/nodes": {
      id: "/_console/settings/platform/nodes";
      path: "/nodes";
      fullPath: "/settings/platform/nodes";
      preLoaderRoute: typeof ConsoleSettingsPlatformNodesRouteImport;
      parentRoute: typeof ConsoleSettingsPlatformRouteRoute;
    };
    "/_console/settings/platform/organizations": {
      id: "/_console/settings/platform/organizations";
      path: "/organizations";
      fullPath: "/settings/platform/organizations";
      preLoaderRoute: typeof ConsoleSettingsPlatformOrganizationsRouteImport;
      parentRoute: typeof ConsoleSettingsPlatformRouteRoute;
    };
    "/_console/settings/platform/principals": {
      id: "/_console/settings/platform/principals";
      path: "/principals";
      fullPath: "/settings/platform/principals";
      preLoaderRoute: typeof ConsoleSettingsPlatformPrincipalsRouteImport;
      parentRoute: typeof ConsoleSettingsPlatformRouteRoute;
    };
    "/_console/settings/projects/": {
      id: "/_console/settings/projects/";
      path: "/";
      fullPath: "/settings/projects/";
      preLoaderRoute: typeof ConsoleSettingsProjectsIndexRouteImport;
      parentRoute: typeof ConsoleSettingsProjectsRoute;
    };
    "/_console/settings/projects/$projectId": {
      id: "/_console/settings/projects/$projectId";
      path: "/$projectId";
      fullPath: "/settings/projects/$projectId";
      preLoaderRoute: typeof ConsoleSettingsProjectsProjectIdRouteImport;
      parentRoute: typeof ConsoleSettingsProjectsRoute;
    };
    "/_console/teleoperators/cockpit/$ticketId": {
      id: "/_console/teleoperators/cockpit/$ticketId";
      path: "/cockpit/$ticketId";
      fullPath: "/teleoperators/cockpit/$ticketId";
      preLoaderRoute: typeof ConsoleTeleoperatorsCockpitTicketIdRouteImport;
      parentRoute: typeof ConsoleTeleoperatorsRouteRoute;
    };
    "/_console/p/$org/$project/": {
      id: "/_console/p/$org/$project/";
      path: "/";
      fullPath: "/p/$org/$project/";
      preLoaderRoute: typeof ConsolePOrgProjectIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/build-worlds": {
      id: "/_console/p/$org/$project/build-worlds";
      path: "/build-worlds";
      fullPath: "/p/$org/$project/build-worlds";
      preLoaderRoute: typeof ConsolePOrgProjectBuildWorldsRouteRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/deploy": {
      id: "/_console/p/$org/$project/deploy";
      path: "/deploy";
      fullPath: "/p/$org/$project/deploy";
      preLoaderRoute: typeof ConsolePOrgProjectDeployRouteRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/library": {
      id: "/_console/p/$org/$project/library";
      path: "/library";
      fullPath: "/p/$org/$project/library";
      preLoaderRoute: typeof ConsolePOrgProjectLibraryRouteRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/operations": {
      id: "/_console/p/$org/$project/operations";
      path: "/operations";
      fullPath: "/p/$org/$project/operations";
      preLoaderRoute: typeof ConsolePOrgProjectOperationsRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/orders": {
      id: "/_console/p/$org/$project/orders";
      path: "/orders";
      fullPath: "/p/$org/$project/orders";
      preLoaderRoute: typeof ConsolePOrgProjectOrdersRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/reports": {
      id: "/_console/p/$org/$project/reports";
      path: "/reports";
      fullPath: "/p/$org/$project/reports";
      preLoaderRoute: typeof ConsolePOrgProjectReportsRouteRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/settings": {
      id: "/_console/p/$org/$project/settings";
      path: "/settings";
      fullPath: "/p/$org/$project/settings";
      preLoaderRoute: typeof ConsolePOrgProjectSettingsRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/simulate": {
      id: "/_console/p/$org/$project/simulate";
      path: "/simulate";
      fullPath: "/p/$org/$project/simulate";
      preLoaderRoute: typeof ConsolePOrgProjectSimulateRouteRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/supply": {
      id: "/_console/p/$org/$project/supply";
      path: "/supply";
      fullPath: "/p/$org/$project/supply";
      preLoaderRoute: typeof ConsolePOrgProjectSupplyRouteRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/tasks": {
      id: "/_console/p/$org/$project/tasks";
      path: "/tasks";
      fullPath: "/p/$org/$project/tasks";
      preLoaderRoute: typeof ConsolePOrgProjectTasksRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/training": {
      id: "/_console/p/$org/$project/training";
      path: "/training";
      fullPath: "/p/$org/$project/training";
      preLoaderRoute: typeof ConsolePOrgProjectTrainingRouteRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/work-atlas": {
      id: "/_console/p/$org/$project/work-atlas";
      path: "/work-atlas";
      fullPath: "/p/$org/$project/work-atlas";
      preLoaderRoute: typeof ConsolePOrgProjectWorkAtlasRouteRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/production/pods/$podId/": {
      id: "/_console/production/pods/$podId/";
      path: "/$podId";
      fullPath: "/production/pods/$podId/";
      preLoaderRoute: typeof ConsoleProductionPodsPodIdIndexRouteImport;
      parentRoute: typeof ConsoleProductionPodsRoute;
    };
    "/_console/production/pods_/$podId/$episodeId": {
      id: "/_console/production/pods_/$podId/$episodeId";
      path: "/pods/$podId/$episodeId";
      fullPath: "/production/pods/$podId/$episodeId";
      preLoaderRoute: typeof ConsoleProductionPodsPodIdEpisodeIdRouteImport;
      parentRoute: typeof ConsoleProductionRouteRoute;
    };
    "/_console/settings/organizations/$organizationId_/billing": {
      id: "/_console/settings/organizations/$organizationId_/billing";
      path: "/$organizationId/billing";
      fullPath: "/settings/organizations/$organizationId/billing";
      preLoaderRoute: typeof ConsoleSettingsOrganizationsOrganizationIdBillingRouteImport;
      parentRoute: typeof ConsoleSettingsOrganizationsRoute;
    };
    "/_console/p/$org/$project/build-worlds/": {
      id: "/_console/p/$org/$project/build-worlds/";
      path: "/";
      fullPath: "/p/$org/$project/build-worlds/";
      preLoaderRoute: typeof ConsolePOrgProjectBuildWorldsIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectBuildWorldsRouteRoute;
    };
    "/_console/p/$org/$project/build-worlds/assets": {
      id: "/_console/p/$org/$project/build-worlds/assets";
      path: "/assets";
      fullPath: "/p/$org/$project/build-worlds/assets";
      preLoaderRoute: typeof ConsolePOrgProjectBuildWorldsAssetsRouteImport;
      parentRoute: typeof ConsolePOrgProjectBuildWorldsRouteRoute;
    };
    "/_console/p/$org/$project/build-worlds/create": {
      id: "/_console/p/$org/$project/build-worlds/create";
      path: "/create";
      fullPath: "/p/$org/$project/build-worlds/create";
      preLoaderRoute: typeof ConsolePOrgProjectBuildWorldsCreateRouteImport;
      parentRoute: typeof ConsolePOrgProjectBuildWorldsRouteRoute;
    };
    "/_console/p/$org/$project/deploy/": {
      id: "/_console/p/$org/$project/deploy/";
      path: "/";
      fullPath: "/p/$org/$project/deploy/";
      preLoaderRoute: typeof ConsolePOrgProjectDeployIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectDeployRouteRoute;
    };
    "/_console/p/$org/$project/deploy/$robot": {
      id: "/_console/p/$org/$project/deploy/$robot";
      path: "/$robot";
      fullPath: "/p/$org/$project/deploy/$robot";
      preLoaderRoute: typeof ConsolePOrgProjectDeployRobotRouteImport;
      parentRoute: typeof ConsolePOrgProjectDeployRouteRoute;
    };
    "/_console/p/$org/$project/deploy/stations": {
      id: "/_console/p/$org/$project/deploy/stations";
      path: "/stations";
      fullPath: "/p/$org/$project/deploy/stations";
      preLoaderRoute: typeof ConsolePOrgProjectDeployStationsRouteImport;
      parentRoute: typeof ConsolePOrgProjectDeployRouteRoute;
    };
    "/_console/p/$org/$project/library/": {
      id: "/_console/p/$org/$project/library/";
      path: "/";
      fullPath: "/p/$org/$project/library/";
      preLoaderRoute: typeof ConsolePOrgProjectLibraryIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
    "/_console/p/$org/$project/library/issues": {
      id: "/_console/p/$org/$project/library/issues";
      path: "/issues";
      fullPath: "/p/$org/$project/library/issues";
      preLoaderRoute: typeof ConsolePOrgProjectLibraryIssuesRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
    "/_console/p/$org/$project/library/map": {
      id: "/_console/p/$org/$project/library/map";
      path: "/map";
      fullPath: "/p/$org/$project/library/map";
      preLoaderRoute: typeof ConsolePOrgProjectLibraryMapRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
    "/_console/p/$org/$project/library/search": {
      id: "/_console/p/$org/$project/library/search";
      path: "/search";
      fullPath: "/p/$org/$project/library/search";
      preLoaderRoute: typeof ConsolePOrgProjectLibrarySearchRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
    "/_console/p/$org/$project/library/semantic": {
      id: "/_console/p/$org/$project/library/semantic";
      path: "/semantic";
      fullPath: "/p/$org/$project/library/semantic";
      preLoaderRoute: typeof ConsolePOrgProjectLibrarySemanticRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
    "/_console/p/$org/$project/loop/": {
      id: "/_console/p/$org/$project/loop/";
      path: "/loop";
      fullPath: "/p/$org/$project/loop/";
      preLoaderRoute: typeof ConsolePOrgProjectLoopIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/loop/board": {
      id: "/_console/p/$org/$project/loop/board";
      path: "/loop/board";
      fullPath: "/p/$org/$project/loop/board";
      preLoaderRoute: typeof ConsolePOrgProjectLoopBoardRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/loop/manager": {
      id: "/_console/p/$org/$project/loop/manager";
      path: "/loop/manager";
      fullPath: "/p/$org/$project/loop/manager";
      preLoaderRoute: typeof ConsolePOrgProjectLoopManagerRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/loop/team": {
      id: "/_console/p/$org/$project/loop/team";
      path: "/loop/team";
      fullPath: "/p/$org/$project/loop/team";
      preLoaderRoute: typeof ConsolePOrgProjectLoopTeamRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/orders/": {
      id: "/_console/p/$org/$project/orders/";
      path: "/";
      fullPath: "/p/$org/$project/orders/";
      preLoaderRoute: typeof ConsolePOrgProjectOrdersIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectOrdersRoute;
    };
    "/_console/p/$org/$project/reports/": {
      id: "/_console/p/$org/$project/reports/";
      path: "/";
      fullPath: "/p/$org/$project/reports/";
      preLoaderRoute: typeof ConsolePOrgProjectReportsIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectReportsRouteRoute;
    };
    "/_console/p/$org/$project/reports/model": {
      id: "/_console/p/$org/$project/reports/model";
      path: "/model";
      fullPath: "/p/$org/$project/reports/model";
      preLoaderRoute: typeof ConsolePOrgProjectReportsModelRouteImport;
      parentRoute: typeof ConsolePOrgProjectReportsRouteRoute;
    };
    "/_console/p/$org/$project/reports/new": {
      id: "/_console/p/$org/$project/reports/new";
      path: "/new";
      fullPath: "/p/$org/$project/reports/new";
      preLoaderRoute: typeof ConsolePOrgProjectReportsNewRouteImport;
      parentRoute: typeof ConsolePOrgProjectReportsRouteRoute;
    };
    "/_console/p/$org/$project/robots/": {
      id: "/_console/p/$org/$project/robots/";
      path: "/robots";
      fullPath: "/p/$org/$project/robots/";
      preLoaderRoute: typeof ConsolePOrgProjectRobotsIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/robots/compose": {
      id: "/_console/p/$org/$project/robots/compose";
      path: "/robots/compose";
      fullPath: "/p/$org/$project/robots/compose";
      preLoaderRoute: typeof ConsolePOrgProjectRobotsComposeRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/simulate/": {
      id: "/_console/p/$org/$project/simulate/";
      path: "/";
      fullPath: "/p/$org/$project/simulate/";
      preLoaderRoute: typeof ConsolePOrgProjectSimulateIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectSimulateRouteRoute;
    };
    "/_console/p/$org/$project/simulate/create": {
      id: "/_console/p/$org/$project/simulate/create";
      path: "/create";
      fullPath: "/p/$org/$project/simulate/create";
      preLoaderRoute: typeof ConsolePOrgProjectSimulateCreateRouteImport;
      parentRoute: typeof ConsolePOrgProjectSimulateRouteRoute;
    };
    "/_console/p/$org/$project/simulate/runs": {
      id: "/_console/p/$org/$project/simulate/runs";
      path: "/runs";
      fullPath: "/p/$org/$project/simulate/runs";
      preLoaderRoute: typeof ConsolePOrgProjectSimulateRunsRouteImport;
      parentRoute: typeof ConsolePOrgProjectSimulateRouteRoute;
    };
    "/_console/p/$org/$project/simulate/sessions": {
      id: "/_console/p/$org/$project/simulate/sessions";
      path: "/sessions";
      fullPath: "/p/$org/$project/simulate/sessions";
      preLoaderRoute: typeof ConsolePOrgProjectSimulateSessionsRouteImport;
      parentRoute: typeof ConsolePOrgProjectSimulateRouteRoute;
    };
    "/_console/p/$org/$project/supply/": {
      id: "/_console/p/$org/$project/supply/";
      path: "/";
      fullPath: "/p/$org/$project/supply/";
      preLoaderRoute: typeof ConsolePOrgProjectSupplyIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectSupplyRouteRoute;
    };
    "/_console/p/$org/$project/supply/orders": {
      id: "/_console/p/$org/$project/supply/orders";
      path: "/orders";
      fullPath: "/p/$org/$project/supply/orders";
      preLoaderRoute: typeof ConsolePOrgProjectSupplyOrdersRouteImport;
      parentRoute: typeof ConsolePOrgProjectSupplyRouteRoute;
    };
    "/_console/p/$org/$project/supply/shipments": {
      id: "/_console/p/$org/$project/supply/shipments";
      path: "/shipments";
      fullPath: "/p/$org/$project/supply/shipments";
      preLoaderRoute: typeof ConsolePOrgProjectSupplyShipmentsRouteImport;
      parentRoute: typeof ConsolePOrgProjectSupplyRouteRoute;
    };
    "/_console/p/$org/$project/tasks/": {
      id: "/_console/p/$org/$project/tasks/";
      path: "/";
      fullPath: "/p/$org/$project/tasks/";
      preLoaderRoute: typeof ConsolePOrgProjectTasksIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectTasksRoute;
    };
    "/_console/p/$org/$project/tasks/$taskId": {
      id: "/_console/p/$org/$project/tasks/$taskId";
      path: "/$taskId";
      fullPath: "/p/$org/$project/tasks/$taskId";
      preLoaderRoute: typeof ConsolePOrgProjectTasksTaskIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectTasksRoute;
    };
    "/_console/p/$org/$project/training/": {
      id: "/_console/p/$org/$project/training/";
      path: "/";
      fullPath: "/p/$org/$project/training/";
      preLoaderRoute: typeof ConsolePOrgProjectTrainingIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectTrainingRouteRoute;
    };
    "/_console/p/$org/$project/training/compare": {
      id: "/_console/p/$org/$project/training/compare";
      path: "/compare";
      fullPath: "/p/$org/$project/training/compare";
      preLoaderRoute: typeof ConsolePOrgProjectTrainingCompareRouteImport;
      parentRoute: typeof ConsolePOrgProjectTrainingRouteRoute;
    };
    "/_console/p/$org/$project/work-atlas/": {
      id: "/_console/p/$org/$project/work-atlas/";
      path: "/";
      fullPath: "/p/$org/$project/work-atlas/";
      preLoaderRoute: typeof ConsolePOrgProjectWorkAtlasIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectWorkAtlasRouteRoute;
    };
    "/_console/p/$org/$project/work-atlas/home": {
      id: "/_console/p/$org/$project/work-atlas/home";
      path: "/home";
      fullPath: "/p/$org/$project/work-atlas/home";
      preLoaderRoute: typeof ConsolePOrgProjectWorkAtlasHomeRouteImport;
      parentRoute: typeof ConsolePOrgProjectWorkAtlasRouteRoute;
    };
    "/_console/p/$org/$project/work-atlas/occupations": {
      id: "/_console/p/$org/$project/work-atlas/occupations";
      path: "/occupations";
      fullPath: "/p/$org/$project/work-atlas/occupations";
      preLoaderRoute: typeof ConsolePOrgProjectWorkAtlasOccupationsRouteImport;
      parentRoute: typeof ConsolePOrgProjectWorkAtlasRouteRoute;
    };
    "/_console/p/$org/$project/work-atlas/opportunities": {
      id: "/_console/p/$org/$project/work-atlas/opportunities";
      path: "/opportunities";
      fullPath: "/p/$org/$project/work-atlas/opportunities";
      preLoaderRoute: typeof ConsolePOrgProjectWorkAtlasOpportunitiesRouteImport;
      parentRoute: typeof ConsolePOrgProjectWorkAtlasRouteRoute;
    };
    "/_console/p/$org/$project/work-atlas/skills": {
      id: "/_console/p/$org/$project/work-atlas/skills";
      path: "/skills";
      fullPath: "/p/$org/$project/work-atlas/skills";
      preLoaderRoute: typeof ConsolePOrgProjectWorkAtlasSkillsRouteImport;
      parentRoute: typeof ConsolePOrgProjectWorkAtlasRouteRoute;
    };
    "/_console/p/$org/$project/work-atlas/tasks": {
      id: "/_console/p/$org/$project/work-atlas/tasks";
      path: "/tasks";
      fullPath: "/p/$org/$project/work-atlas/tasks";
      preLoaderRoute: typeof ConsolePOrgProjectWorkAtlasTasksRouteImport;
      parentRoute: typeof ConsolePOrgProjectWorkAtlasRouteRoute;
    };
    "/_console/p/$org/$project/build-worlds/assets/$worldId": {
      id: "/_console/p/$org/$project/build-worlds/assets/$worldId";
      path: "/$worldId";
      fullPath: "/p/$org/$project/build-worlds/assets/$worldId";
      preLoaderRoute: typeof ConsolePOrgProjectBuildWorldsAssetsWorldIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectBuildWorldsAssetsRoute;
    };
    "/_console/p/$org/$project/build-worlds/drafts/$draftId": {
      id: "/_console/p/$org/$project/build-worlds/drafts/$draftId";
      path: "/drafts/$draftId";
      fullPath: "/p/$org/$project/build-worlds/drafts/$draftId";
      preLoaderRoute: typeof ConsolePOrgProjectBuildWorldsDraftsDraftIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectBuildWorldsRouteRoute;
    };
    "/_console/p/$org/$project/deploy/ladders/$": {
      id: "/_console/p/$org/$project/deploy/ladders/$";
      path: "/ladders/$";
      fullPath: "/p/$org/$project/deploy/ladders/$";
      preLoaderRoute: typeof ConsolePOrgProjectDeployLaddersSplatRouteImport;
      parentRoute: typeof ConsolePOrgProjectDeployRouteRoute;
    };
    "/_console/p/$org/$project/deploy/stations/": {
      id: "/_console/p/$org/$project/deploy/stations/";
      path: "/";
      fullPath: "/p/$org/$project/deploy/stations/";
      preLoaderRoute: typeof ConsolePOrgProjectDeployStationsIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectDeployStationsRoute;
    };
    "/_console/p/$org/$project/deploy/stations/$stationId": {
      id: "/_console/p/$org/$project/deploy/stations/$stationId";
      path: "/$stationId";
      fullPath: "/p/$org/$project/deploy/stations/$stationId";
      preLoaderRoute: typeof ConsolePOrgProjectDeployStationsStationIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectDeployStationsRoute;
    };
    "/_console/p/$org/$project/library/agents/$agentId": {
      id: "/_console/p/$org/$project/library/agents/$agentId";
      path: "/agents/$agentId";
      fullPath: "/p/$org/$project/library/agents/$agentId";
      preLoaderRoute: typeof ConsolePOrgProjectLibraryAgentsAgentIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
    "/_console/p/$org/$project/library/contracts/$id": {
      id: "/_console/p/$org/$project/library/contracts/$id";
      path: "/contracts/$id";
      fullPath: "/p/$org/$project/library/contracts/$id";
      preLoaderRoute: typeof ConsolePOrgProjectLibraryContractsIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
    "/_console/p/$org/$project/library/items/$name": {
      id: "/_console/p/$org/$project/library/items/$name";
      path: "/items/$name";
      fullPath: "/p/$org/$project/library/items/$name";
      preLoaderRoute: typeof ConsolePOrgProjectLibraryItemsNameRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
    "/_console/p/$org/$project/reports/$name/": {
      id: "/_console/p/$org/$project/reports/$name/";
      path: "/$name";
      fullPath: "/p/$org/$project/reports/$name/";
      preLoaderRoute: typeof ConsolePOrgProjectReportsNameIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectReportsRouteRoute;
    };
    "/_console/p/$org/$project/reports/$name/changes": {
      id: "/_console/p/$org/$project/reports/$name/changes";
      path: "/$name/changes";
      fullPath: "/p/$org/$project/reports/$name/changes";
      preLoaderRoute: typeof ConsolePOrgProjectReportsNameChangesRouteImport;
      parentRoute: typeof ConsolePOrgProjectReportsRouteRoute;
    };
    "/_console/p/$org/$project/reports/$name/edit": {
      id: "/_console/p/$org/$project/reports/$name/edit";
      path: "/$name/edit";
      fullPath: "/p/$org/$project/reports/$name/edit";
      preLoaderRoute: typeof ConsolePOrgProjectReportsNameEditRouteImport;
      parentRoute: typeof ConsolePOrgProjectReportsRouteRoute;
    };
    "/_console/p/$org/$project/robots/bodies/$body": {
      id: "/_console/p/$org/$project/robots/bodies/$body";
      path: "/robots/bodies/$body";
      fullPath: "/p/$org/$project/robots/bodies/$body";
      preLoaderRoute: typeof ConsolePOrgProjectRobotsBodiesBodyRouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/simulate/assets/$worldId": {
      id: "/_console/p/$org/$project/simulate/assets/$worldId";
      path: "/assets/$worldId";
      fullPath: "/p/$org/$project/simulate/assets/$worldId";
      preLoaderRoute: typeof ConsolePOrgProjectSimulateAssetsWorldIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectSimulateRouteRoute;
    };
    "/_console/p/$org/$project/simulate/drafts/": {
      id: "/_console/p/$org/$project/simulate/drafts/";
      path: "/drafts";
      fullPath: "/p/$org/$project/simulate/drafts/";
      preLoaderRoute: typeof ConsolePOrgProjectSimulateDraftsIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectSimulateRouteRoute;
    };
    "/_console/p/$org/$project/simulate/drafts/$draftId": {
      id: "/_console/p/$org/$project/simulate/drafts/$draftId";
      path: "/drafts/$draftId";
      fullPath: "/p/$org/$project/simulate/drafts/$draftId";
      preLoaderRoute: typeof ConsolePOrgProjectSimulateDraftsDraftIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectSimulateRouteRoute;
    };
    "/_console/p/$org/$project/training/jobs/$jobId": {
      id: "/_console/p/$org/$project/training/jobs/$jobId";
      path: "/jobs/$jobId";
      fullPath: "/p/$org/$project/training/jobs/$jobId";
      preLoaderRoute: typeof ConsolePOrgProjectTrainingJobsJobIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectTrainingRouteRoute;
    };
    "/_console/p/$org/$project/training/research/": {
      id: "/_console/p/$org/$project/training/research/";
      path: "/research";
      fullPath: "/p/$org/$project/training/research/";
      preLoaderRoute: typeof ConsolePOrgProjectTrainingResearchIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectTrainingRouteRoute;
    };
    "/_console/p/$org/$project/training/research/$sessionName": {
      id: "/_console/p/$org/$project/training/research/$sessionName";
      path: "/research/$sessionName";
      fullPath: "/p/$org/$project/training/research/$sessionName";
      preLoaderRoute: typeof ConsolePOrgProjectTrainingResearchSessionNameRouteImport;
      parentRoute: typeof ConsolePOrgProjectTrainingRouteRoute;
    };
    "/_console/p/$org/$project/training/runs/": {
      id: "/_console/p/$org/$project/training/runs/";
      path: "/runs";
      fullPath: "/p/$org/$project/training/runs/";
      preLoaderRoute: typeof ConsolePOrgProjectTrainingRunsIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectTrainingRouteRoute;
    };
    "/_console/p/$org/$project/training/runs/$runId": {
      id: "/_console/p/$org/$project/training/runs/$runId";
      path: "/runs/$runId";
      fullPath: "/p/$org/$project/training/runs/$runId";
      preLoaderRoute: typeof ConsolePOrgProjectTrainingRunsRunIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectTrainingRouteRoute;
    };
    "/_console/p/$org/$project/deploy/$robot_/sessions/$session": {
      id: "/_console/p/$org/$project/deploy/$robot_/sessions/$session";
      path: "/$robot/sessions/$session";
      fullPath: "/p/$org/$project/deploy/$robot/sessions/$session";
      preLoaderRoute: typeof ConsolePOrgProjectDeployRobotSessionsSessionRouteImport;
      parentRoute: typeof ConsolePOrgProjectDeployRouteRoute;
    };
    "/_console/p/$org/$project/library/datasets/$name/": {
      id: "/_console/p/$org/$project/library/datasets/$name/";
      path: "/datasets/$name";
      fullPath: "/p/$org/$project/library/datasets/$name/";
      preLoaderRoute: typeof ConsolePOrgProjectLibraryDatasetsNameIndexRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
    "/_console/p/$org/$project/library/episodes/$sessionId/$episodeId": {
      id: "/_console/p/$org/$project/library/episodes/$sessionId/$episodeId";
      path: "/episodes/$sessionId/$episodeId";
      fullPath: "/p/$org/$project/library/episodes/$sessionId/$episodeId";
      preLoaderRoute: typeof ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
    "/_console/p/$org/$project/loop/agent/$agentId/{-$sessionId}": {
      id: "/_console/p/$org/$project/loop/agent/$agentId/{-$sessionId}";
      path: "/loop/agent/$agentId/{-$sessionId}";
      fullPath: "/p/$org/$project/loop/agent/$agentId/{-$sessionId}";
      preLoaderRoute: typeof ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125RouteImport;
      parentRoute: typeof ConsolePOrgProjectRoute;
    };
    "/_console/p/$org/$project/reports/$name/versions/$version": {
      id: "/_console/p/$org/$project/reports/$name/versions/$version";
      path: "/$name/versions/$version";
      fullPath: "/p/$org/$project/reports/$name/versions/$version";
      preLoaderRoute: typeof ConsolePOrgProjectReportsNameVersionsVersionRouteImport;
      parentRoute: typeof ConsolePOrgProjectReportsRouteRoute;
    };
    "/_console/p/$org/$project/library/datasets/$name/segments/$segmentId": {
      id: "/_console/p/$org/$project/library/datasets/$name/segments/$segmentId";
      path: "/datasets/$name/segments/$segmentId";
      fullPath: "/p/$org/$project/library/datasets/$name/segments/$segmentId";
      preLoaderRoute: typeof ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRouteImport;
      parentRoute: typeof ConsolePOrgProjectLibraryRouteRoute;
    };
  }
}

interface ConsoleLabelQcRouteChildren {
  ConsoleLabelQcAccuracyRoute: typeof ConsoleLabelQcAccuracyRoute;
  ConsoleLabelQcIndexRoute: typeof ConsoleLabelQcIndexRoute;
}

const ConsoleLabelQcRouteChildren: ConsoleLabelQcRouteChildren = {
  ConsoleLabelQcAccuracyRoute: ConsoleLabelQcAccuracyRoute,
  ConsoleLabelQcIndexRoute: ConsoleLabelQcIndexRoute,
};

const ConsoleLabelQcRouteWithChildren = ConsoleLabelQcRoute._addFileChildren(
  ConsoleLabelQcRouteChildren,
);

interface ConsoleLabelRouteRouteChildren {
  ConsoleLabelAdminRoute: typeof ConsoleLabelAdminRoute;
  ConsoleLabelPrincipalRoute: typeof ConsoleLabelPrincipalRoute;
  ConsoleLabelQcRoute: typeof ConsoleLabelQcRouteWithChildren;
  ConsoleLabelIndexRoute: typeof ConsoleLabelIndexRoute;
  ConsoleLabelAnnotateEpisodeIdRoute: typeof ConsoleLabelAnnotateEpisodeIdRoute;
  ConsoleLabelAuditEpisodeIdRoute: typeof ConsoleLabelAuditEpisodeIdRoute;
  ConsoleLabelAuditIndexRoute: typeof ConsoleLabelAuditIndexRoute;
}

const ConsoleLabelRouteRouteChildren: ConsoleLabelRouteRouteChildren = {
  ConsoleLabelAdminRoute: ConsoleLabelAdminRoute,
  ConsoleLabelPrincipalRoute: ConsoleLabelPrincipalRoute,
  ConsoleLabelQcRoute: ConsoleLabelQcRouteWithChildren,
  ConsoleLabelIndexRoute: ConsoleLabelIndexRoute,
  ConsoleLabelAnnotateEpisodeIdRoute: ConsoleLabelAnnotateEpisodeIdRoute,
  ConsoleLabelAuditEpisodeIdRoute: ConsoleLabelAuditEpisodeIdRoute,
  ConsoleLabelAuditIndexRoute: ConsoleLabelAuditIndexRoute,
};

const ConsoleLabelRouteRouteWithChildren =
  ConsoleLabelRouteRoute._addFileChildren(ConsoleLabelRouteRouteChildren);

interface ConsoleOperationsRouteRouteChildren {
  ConsoleOperationsReleasesRoute: typeof ConsoleOperationsReleasesRoute;
  ConsoleOperationsIndexRoute: typeof ConsoleOperationsIndexRoute;
}

const ConsoleOperationsRouteRouteChildren: ConsoleOperationsRouteRouteChildren =
  {
    ConsoleOperationsReleasesRoute: ConsoleOperationsReleasesRoute,
    ConsoleOperationsIndexRoute: ConsoleOperationsIndexRoute,
  };

const ConsoleOperationsRouteRouteWithChildren =
  ConsoleOperationsRouteRoute._addFileChildren(
    ConsoleOperationsRouteRouteChildren,
  );

interface ConsoleProductionPodsRouteChildren {
  ConsoleProductionPodsIndexRoute: typeof ConsoleProductionPodsIndexRoute;
  ConsoleProductionPodsPodIdIndexRoute: typeof ConsoleProductionPodsPodIdIndexRoute;
}

const ConsoleProductionPodsRouteChildren: ConsoleProductionPodsRouteChildren = {
  ConsoleProductionPodsIndexRoute: ConsoleProductionPodsIndexRoute,
  ConsoleProductionPodsPodIdIndexRoute: ConsoleProductionPodsPodIdIndexRoute,
};

const ConsoleProductionPodsRouteWithChildren =
  ConsoleProductionPodsRoute._addFileChildren(
    ConsoleProductionPodsRouteChildren,
  );

interface ConsoleProductionRouteRouteChildren {
  ConsoleProductionActivityRoute: typeof ConsoleProductionActivityRoute;
  ConsoleProductionChecksRoute: typeof ConsoleProductionChecksRoute;
  ConsoleProductionCollectionsRoute: typeof ConsoleProductionCollectionsRoute;
  ConsoleProductionEpisodesRoute: typeof ConsoleProductionEpisodesRoute;
  ConsoleProductionOperatorsRoute: typeof ConsoleProductionOperatorsRoute;
  ConsoleProductionPeopleRoute: typeof ConsoleProductionPeopleRoute;
  ConsoleProductionPodsRoute: typeof ConsoleProductionPodsRouteWithChildren;
  ConsoleProductionUploadsRoute: typeof ConsoleProductionUploadsRoute;
  ConsoleProductionIndexRoute: typeof ConsoleProductionIndexRoute;
  ConsoleProductionCollectionsCollectionIdRoute: typeof ConsoleProductionCollectionsCollectionIdRoute;
  ConsoleProductionEpisodesEpisodeIdRoute: typeof ConsoleProductionEpisodesEpisodeIdRoute;
  ConsoleProductionPodsPodIdEpisodeIdRoute: typeof ConsoleProductionPodsPodIdEpisodeIdRoute;
}

const ConsoleProductionRouteRouteChildren: ConsoleProductionRouteRouteChildren =
  {
    ConsoleProductionActivityRoute: ConsoleProductionActivityRoute,
    ConsoleProductionChecksRoute: ConsoleProductionChecksRoute,
    ConsoleProductionCollectionsRoute: ConsoleProductionCollectionsRoute,
    ConsoleProductionEpisodesRoute: ConsoleProductionEpisodesRoute,
    ConsoleProductionOperatorsRoute: ConsoleProductionOperatorsRoute,
    ConsoleProductionPeopleRoute: ConsoleProductionPeopleRoute,
    ConsoleProductionPodsRoute: ConsoleProductionPodsRouteWithChildren,
    ConsoleProductionUploadsRoute: ConsoleProductionUploadsRoute,
    ConsoleProductionIndexRoute: ConsoleProductionIndexRoute,
    ConsoleProductionCollectionsCollectionIdRoute:
      ConsoleProductionCollectionsCollectionIdRoute,
    ConsoleProductionEpisodesEpisodeIdRoute:
      ConsoleProductionEpisodesEpisodeIdRoute,
    ConsoleProductionPodsPodIdEpisodeIdRoute:
      ConsoleProductionPodsPodIdEpisodeIdRoute,
  };

const ConsoleProductionRouteRouteWithChildren =
  ConsoleProductionRouteRoute._addFileChildren(
    ConsoleProductionRouteRouteChildren,
  );

interface ConsoleSettingsPlatformRouteRouteChildren {
  ConsoleSettingsPlatformActAsRoute: typeof ConsoleSettingsPlatformActAsRoute;
  ConsoleSettingsPlatformAudiencesRoute: typeof ConsoleSettingsPlatformAudiencesRoute;
  ConsoleSettingsPlatformNodesRoute: typeof ConsoleSettingsPlatformNodesRoute;
  ConsoleSettingsPlatformOrganizationsRoute: typeof ConsoleSettingsPlatformOrganizationsRoute;
  ConsoleSettingsPlatformPrincipalsRoute: typeof ConsoleSettingsPlatformPrincipalsRoute;
  ConsoleSettingsPlatformIndexRoute: typeof ConsoleSettingsPlatformIndexRoute;
}

const ConsoleSettingsPlatformRouteRouteChildren: ConsoleSettingsPlatformRouteRouteChildren =
  {
    ConsoleSettingsPlatformActAsRoute: ConsoleSettingsPlatformActAsRoute,
    ConsoleSettingsPlatformAudiencesRoute:
      ConsoleSettingsPlatformAudiencesRoute,
    ConsoleSettingsPlatformNodesRoute: ConsoleSettingsPlatformNodesRoute,
    ConsoleSettingsPlatformOrganizationsRoute:
      ConsoleSettingsPlatformOrganizationsRoute,
    ConsoleSettingsPlatformPrincipalsRoute:
      ConsoleSettingsPlatformPrincipalsRoute,
    ConsoleSettingsPlatformIndexRoute: ConsoleSettingsPlatformIndexRoute,
  };

const ConsoleSettingsPlatformRouteRouteWithChildren =
  ConsoleSettingsPlatformRouteRoute._addFileChildren(
    ConsoleSettingsPlatformRouteRouteChildren,
  );

interface ConsoleSettingsOrganizationsRouteChildren {
  ConsoleSettingsOrganizationsOrganizationIdRoute: typeof ConsoleSettingsOrganizationsOrganizationIdRoute;
  ConsoleSettingsOrganizationsIndexRoute: typeof ConsoleSettingsOrganizationsIndexRoute;
  ConsoleSettingsOrganizationsOrganizationIdBillingRoute: typeof ConsoleSettingsOrganizationsOrganizationIdBillingRoute;
}

const ConsoleSettingsOrganizationsRouteChildren: ConsoleSettingsOrganizationsRouteChildren =
  {
    ConsoleSettingsOrganizationsOrganizationIdRoute:
      ConsoleSettingsOrganizationsOrganizationIdRoute,
    ConsoleSettingsOrganizationsIndexRoute:
      ConsoleSettingsOrganizationsIndexRoute,
    ConsoleSettingsOrganizationsOrganizationIdBillingRoute:
      ConsoleSettingsOrganizationsOrganizationIdBillingRoute,
  };

const ConsoleSettingsOrganizationsRouteWithChildren =
  ConsoleSettingsOrganizationsRoute._addFileChildren(
    ConsoleSettingsOrganizationsRouteChildren,
  );

interface ConsoleSettingsProjectsRouteChildren {
  ConsoleSettingsProjectsProjectIdRoute: typeof ConsoleSettingsProjectsProjectIdRoute;
  ConsoleSettingsProjectsIndexRoute: typeof ConsoleSettingsProjectsIndexRoute;
}

const ConsoleSettingsProjectsRouteChildren: ConsoleSettingsProjectsRouteChildren =
  {
    ConsoleSettingsProjectsProjectIdRoute:
      ConsoleSettingsProjectsProjectIdRoute,
    ConsoleSettingsProjectsIndexRoute: ConsoleSettingsProjectsIndexRoute,
  };

const ConsoleSettingsProjectsRouteWithChildren =
  ConsoleSettingsProjectsRoute._addFileChildren(
    ConsoleSettingsProjectsRouteChildren,
  );

interface ConsoleSettingsRouteRouteChildren {
  ConsoleSettingsPlatformRouteRoute: typeof ConsoleSettingsPlatformRouteRouteWithChildren;
  ConsoleSettingsBillingRoute: typeof ConsoleSettingsBillingRoute;
  ConsoleSettingsKeysRoute: typeof ConsoleSettingsKeysRoute;
  ConsoleSettingsOperatorsRoute: typeof ConsoleSettingsOperatorsRoute;
  ConsoleSettingsOrganizationsRoute: typeof ConsoleSettingsOrganizationsRouteWithChildren;
  ConsoleSettingsPeopleRoute: typeof ConsoleSettingsPeopleRoute;
  ConsoleSettingsProjectsRoute: typeof ConsoleSettingsProjectsRouteWithChildren;
  ConsoleSettingsSessionsRoute: typeof ConsoleSettingsSessionsRoute;
  ConsoleSettingsIndexRoute: typeof ConsoleSettingsIndexRoute;
}

const ConsoleSettingsRouteRouteChildren: ConsoleSettingsRouteRouteChildren = {
  ConsoleSettingsPlatformRouteRoute:
    ConsoleSettingsPlatformRouteRouteWithChildren,
  ConsoleSettingsBillingRoute: ConsoleSettingsBillingRoute,
  ConsoleSettingsKeysRoute: ConsoleSettingsKeysRoute,
  ConsoleSettingsOperatorsRoute: ConsoleSettingsOperatorsRoute,
  ConsoleSettingsOrganizationsRoute:
    ConsoleSettingsOrganizationsRouteWithChildren,
  ConsoleSettingsPeopleRoute: ConsoleSettingsPeopleRoute,
  ConsoleSettingsProjectsRoute: ConsoleSettingsProjectsRouteWithChildren,
  ConsoleSettingsSessionsRoute: ConsoleSettingsSessionsRoute,
  ConsoleSettingsIndexRoute: ConsoleSettingsIndexRoute,
};

const ConsoleSettingsRouteRouteWithChildren =
  ConsoleSettingsRouteRoute._addFileChildren(ConsoleSettingsRouteRouteChildren);

interface ConsoleTeleoperatorsRouteRouteChildren {
  ConsoleTeleoperatorsPeopleRoute: typeof ConsoleTeleoperatorsPeopleRoute;
  ConsoleTeleoperatorsSessionsRoute: typeof ConsoleTeleoperatorsSessionsRoute;
  ConsoleTeleoperatorsIndexRoute: typeof ConsoleTeleoperatorsIndexRoute;
  ConsoleTeleoperatorsCockpitTicketIdRoute: typeof ConsoleTeleoperatorsCockpitTicketIdRoute;
}

const ConsoleTeleoperatorsRouteRouteChildren: ConsoleTeleoperatorsRouteRouteChildren =
  {
    ConsoleTeleoperatorsPeopleRoute: ConsoleTeleoperatorsPeopleRoute,
    ConsoleTeleoperatorsSessionsRoute: ConsoleTeleoperatorsSessionsRoute,
    ConsoleTeleoperatorsIndexRoute: ConsoleTeleoperatorsIndexRoute,
    ConsoleTeleoperatorsCockpitTicketIdRoute:
      ConsoleTeleoperatorsCockpitTicketIdRoute,
  };

const ConsoleTeleoperatorsRouteRouteWithChildren =
  ConsoleTeleoperatorsRouteRoute._addFileChildren(
    ConsoleTeleoperatorsRouteRouteChildren,
  );

interface ConsoleProjectsRouteChildren {
  ConsoleProjectsIndexRoute: typeof ConsoleProjectsIndexRoute;
}

const ConsoleProjectsRouteChildren: ConsoleProjectsRouteChildren = {
  ConsoleProjectsIndexRoute: ConsoleProjectsIndexRoute,
};

const ConsoleProjectsRouteWithChildren = ConsoleProjectsRoute._addFileChildren(
  ConsoleProjectsRouteChildren,
);

interface ConsolePOrgProjectBuildWorldsAssetsRouteChildren {
  ConsolePOrgProjectBuildWorldsAssetsWorldIdRoute: typeof ConsolePOrgProjectBuildWorldsAssetsWorldIdRoute;
}

const ConsolePOrgProjectBuildWorldsAssetsRouteChildren: ConsolePOrgProjectBuildWorldsAssetsRouteChildren =
  {
    ConsolePOrgProjectBuildWorldsAssetsWorldIdRoute:
      ConsolePOrgProjectBuildWorldsAssetsWorldIdRoute,
  };

const ConsolePOrgProjectBuildWorldsAssetsRouteWithChildren =
  ConsolePOrgProjectBuildWorldsAssetsRoute._addFileChildren(
    ConsolePOrgProjectBuildWorldsAssetsRouteChildren,
  );

interface ConsolePOrgProjectBuildWorldsRouteRouteChildren {
  ConsolePOrgProjectBuildWorldsAssetsRoute: typeof ConsolePOrgProjectBuildWorldsAssetsRouteWithChildren;
  ConsolePOrgProjectBuildWorldsCreateRoute: typeof ConsolePOrgProjectBuildWorldsCreateRoute;
  ConsolePOrgProjectBuildWorldsIndexRoute: typeof ConsolePOrgProjectBuildWorldsIndexRoute;
  ConsolePOrgProjectBuildWorldsDraftsDraftIdRoute: typeof ConsolePOrgProjectBuildWorldsDraftsDraftIdRoute;
}

const ConsolePOrgProjectBuildWorldsRouteRouteChildren: ConsolePOrgProjectBuildWorldsRouteRouteChildren =
  {
    ConsolePOrgProjectBuildWorldsAssetsRoute:
      ConsolePOrgProjectBuildWorldsAssetsRouteWithChildren,
    ConsolePOrgProjectBuildWorldsCreateRoute:
      ConsolePOrgProjectBuildWorldsCreateRoute,
    ConsolePOrgProjectBuildWorldsIndexRoute:
      ConsolePOrgProjectBuildWorldsIndexRoute,
    ConsolePOrgProjectBuildWorldsDraftsDraftIdRoute:
      ConsolePOrgProjectBuildWorldsDraftsDraftIdRoute,
  };

const ConsolePOrgProjectBuildWorldsRouteRouteWithChildren =
  ConsolePOrgProjectBuildWorldsRouteRoute._addFileChildren(
    ConsolePOrgProjectBuildWorldsRouteRouteChildren,
  );

interface ConsolePOrgProjectDeployStationsRouteChildren {
  ConsolePOrgProjectDeployStationsStationIdRoute: typeof ConsolePOrgProjectDeployStationsStationIdRoute;
  ConsolePOrgProjectDeployStationsIndexRoute: typeof ConsolePOrgProjectDeployStationsIndexRoute;
}

const ConsolePOrgProjectDeployStationsRouteChildren: ConsolePOrgProjectDeployStationsRouteChildren =
  {
    ConsolePOrgProjectDeployStationsStationIdRoute:
      ConsolePOrgProjectDeployStationsStationIdRoute,
    ConsolePOrgProjectDeployStationsIndexRoute:
      ConsolePOrgProjectDeployStationsIndexRoute,
  };

const ConsolePOrgProjectDeployStationsRouteWithChildren =
  ConsolePOrgProjectDeployStationsRoute._addFileChildren(
    ConsolePOrgProjectDeployStationsRouteChildren,
  );

interface ConsolePOrgProjectDeployRouteRouteChildren {
  ConsolePOrgProjectDeployRobotRoute: typeof ConsolePOrgProjectDeployRobotRoute;
  ConsolePOrgProjectDeployStationsRoute: typeof ConsolePOrgProjectDeployStationsRouteWithChildren;
  ConsolePOrgProjectDeployIndexRoute: typeof ConsolePOrgProjectDeployIndexRoute;
  ConsolePOrgProjectDeployLaddersSplatRoute: typeof ConsolePOrgProjectDeployLaddersSplatRoute;
  ConsolePOrgProjectDeployRobotSessionsSessionRoute: typeof ConsolePOrgProjectDeployRobotSessionsSessionRoute;
}

const ConsolePOrgProjectDeployRouteRouteChildren: ConsolePOrgProjectDeployRouteRouteChildren =
  {
    ConsolePOrgProjectDeployRobotRoute: ConsolePOrgProjectDeployRobotRoute,
    ConsolePOrgProjectDeployStationsRoute:
      ConsolePOrgProjectDeployStationsRouteWithChildren,
    ConsolePOrgProjectDeployIndexRoute: ConsolePOrgProjectDeployIndexRoute,
    ConsolePOrgProjectDeployLaddersSplatRoute:
      ConsolePOrgProjectDeployLaddersSplatRoute,
    ConsolePOrgProjectDeployRobotSessionsSessionRoute:
      ConsolePOrgProjectDeployRobotSessionsSessionRoute,
  };

const ConsolePOrgProjectDeployRouteRouteWithChildren =
  ConsolePOrgProjectDeployRouteRoute._addFileChildren(
    ConsolePOrgProjectDeployRouteRouteChildren,
  );

interface ConsolePOrgProjectLibraryRouteRouteChildren {
  ConsolePOrgProjectLibraryIssuesRoute: typeof ConsolePOrgProjectLibraryIssuesRoute;
  ConsolePOrgProjectLibraryMapRoute: typeof ConsolePOrgProjectLibraryMapRoute;
  ConsolePOrgProjectLibrarySearchRoute: typeof ConsolePOrgProjectLibrarySearchRoute;
  ConsolePOrgProjectLibrarySemanticRoute: typeof ConsolePOrgProjectLibrarySemanticRoute;
  ConsolePOrgProjectLibraryIndexRoute: typeof ConsolePOrgProjectLibraryIndexRoute;
  ConsolePOrgProjectLibraryAgentsAgentIdRoute: typeof ConsolePOrgProjectLibraryAgentsAgentIdRoute;
  ConsolePOrgProjectLibraryContractsIdRoute: typeof ConsolePOrgProjectLibraryContractsIdRoute;
  ConsolePOrgProjectLibraryItemsNameRoute: typeof ConsolePOrgProjectLibraryItemsNameRoute;
  ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRoute: typeof ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRoute;
  ConsolePOrgProjectLibraryDatasetsNameIndexRoute: typeof ConsolePOrgProjectLibraryDatasetsNameIndexRoute;
  ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRoute: typeof ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRoute;
}

const ConsolePOrgProjectLibraryRouteRouteChildren: ConsolePOrgProjectLibraryRouteRouteChildren =
  {
    ConsolePOrgProjectLibraryIssuesRoute: ConsolePOrgProjectLibraryIssuesRoute,
    ConsolePOrgProjectLibraryMapRoute: ConsolePOrgProjectLibraryMapRoute,
    ConsolePOrgProjectLibrarySearchRoute: ConsolePOrgProjectLibrarySearchRoute,
    ConsolePOrgProjectLibrarySemanticRoute:
      ConsolePOrgProjectLibrarySemanticRoute,
    ConsolePOrgProjectLibraryIndexRoute: ConsolePOrgProjectLibraryIndexRoute,
    ConsolePOrgProjectLibraryAgentsAgentIdRoute:
      ConsolePOrgProjectLibraryAgentsAgentIdRoute,
    ConsolePOrgProjectLibraryContractsIdRoute:
      ConsolePOrgProjectLibraryContractsIdRoute,
    ConsolePOrgProjectLibraryItemsNameRoute:
      ConsolePOrgProjectLibraryItemsNameRoute,
    ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRoute:
      ConsolePOrgProjectLibraryEpisodesSessionIdEpisodeIdRoute,
    ConsolePOrgProjectLibraryDatasetsNameIndexRoute:
      ConsolePOrgProjectLibraryDatasetsNameIndexRoute,
    ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRoute:
      ConsolePOrgProjectLibraryDatasetsNameSegmentsSegmentIdRoute,
  };

const ConsolePOrgProjectLibraryRouteRouteWithChildren =
  ConsolePOrgProjectLibraryRouteRoute._addFileChildren(
    ConsolePOrgProjectLibraryRouteRouteChildren,
  );

interface ConsolePOrgProjectReportsRouteRouteChildren {
  ConsolePOrgProjectReportsModelRoute: typeof ConsolePOrgProjectReportsModelRoute;
  ConsolePOrgProjectReportsNewRoute: typeof ConsolePOrgProjectReportsNewRoute;
  ConsolePOrgProjectReportsIndexRoute: typeof ConsolePOrgProjectReportsIndexRoute;
  ConsolePOrgProjectReportsNameChangesRoute: typeof ConsolePOrgProjectReportsNameChangesRoute;
  ConsolePOrgProjectReportsNameEditRoute: typeof ConsolePOrgProjectReportsNameEditRoute;
  ConsolePOrgProjectReportsNameIndexRoute: typeof ConsolePOrgProjectReportsNameIndexRoute;
  ConsolePOrgProjectReportsNameVersionsVersionRoute: typeof ConsolePOrgProjectReportsNameVersionsVersionRoute;
}

const ConsolePOrgProjectReportsRouteRouteChildren: ConsolePOrgProjectReportsRouteRouteChildren =
  {
    ConsolePOrgProjectReportsModelRoute: ConsolePOrgProjectReportsModelRoute,
    ConsolePOrgProjectReportsNewRoute: ConsolePOrgProjectReportsNewRoute,
    ConsolePOrgProjectReportsIndexRoute: ConsolePOrgProjectReportsIndexRoute,
    ConsolePOrgProjectReportsNameChangesRoute:
      ConsolePOrgProjectReportsNameChangesRoute,
    ConsolePOrgProjectReportsNameEditRoute:
      ConsolePOrgProjectReportsNameEditRoute,
    ConsolePOrgProjectReportsNameIndexRoute:
      ConsolePOrgProjectReportsNameIndexRoute,
    ConsolePOrgProjectReportsNameVersionsVersionRoute:
      ConsolePOrgProjectReportsNameVersionsVersionRoute,
  };

const ConsolePOrgProjectReportsRouteRouteWithChildren =
  ConsolePOrgProjectReportsRouteRoute._addFileChildren(
    ConsolePOrgProjectReportsRouteRouteChildren,
  );

interface ConsolePOrgProjectSimulateRouteRouteChildren {
  ConsolePOrgProjectSimulateCreateRoute: typeof ConsolePOrgProjectSimulateCreateRoute;
  ConsolePOrgProjectSimulateRunsRoute: typeof ConsolePOrgProjectSimulateRunsRoute;
  ConsolePOrgProjectSimulateSessionsRoute: typeof ConsolePOrgProjectSimulateSessionsRoute;
  ConsolePOrgProjectSimulateIndexRoute: typeof ConsolePOrgProjectSimulateIndexRoute;
  ConsolePOrgProjectSimulateAssetsWorldIdRoute: typeof ConsolePOrgProjectSimulateAssetsWorldIdRoute;
  ConsolePOrgProjectSimulateDraftsDraftIdRoute: typeof ConsolePOrgProjectSimulateDraftsDraftIdRoute;
  ConsolePOrgProjectSimulateDraftsIndexRoute: typeof ConsolePOrgProjectSimulateDraftsIndexRoute;
}

const ConsolePOrgProjectSimulateRouteRouteChildren: ConsolePOrgProjectSimulateRouteRouteChildren =
  {
    ConsolePOrgProjectSimulateCreateRoute:
      ConsolePOrgProjectSimulateCreateRoute,
    ConsolePOrgProjectSimulateRunsRoute: ConsolePOrgProjectSimulateRunsRoute,
    ConsolePOrgProjectSimulateSessionsRoute:
      ConsolePOrgProjectSimulateSessionsRoute,
    ConsolePOrgProjectSimulateIndexRoute: ConsolePOrgProjectSimulateIndexRoute,
    ConsolePOrgProjectSimulateAssetsWorldIdRoute:
      ConsolePOrgProjectSimulateAssetsWorldIdRoute,
    ConsolePOrgProjectSimulateDraftsDraftIdRoute:
      ConsolePOrgProjectSimulateDraftsDraftIdRoute,
    ConsolePOrgProjectSimulateDraftsIndexRoute:
      ConsolePOrgProjectSimulateDraftsIndexRoute,
  };

const ConsolePOrgProjectSimulateRouteRouteWithChildren =
  ConsolePOrgProjectSimulateRouteRoute._addFileChildren(
    ConsolePOrgProjectSimulateRouteRouteChildren,
  );

interface ConsolePOrgProjectSupplyRouteRouteChildren {
  ConsolePOrgProjectSupplyOrdersRoute: typeof ConsolePOrgProjectSupplyOrdersRoute;
  ConsolePOrgProjectSupplyShipmentsRoute: typeof ConsolePOrgProjectSupplyShipmentsRoute;
  ConsolePOrgProjectSupplyIndexRoute: typeof ConsolePOrgProjectSupplyIndexRoute;
}

const ConsolePOrgProjectSupplyRouteRouteChildren: ConsolePOrgProjectSupplyRouteRouteChildren =
  {
    ConsolePOrgProjectSupplyOrdersRoute: ConsolePOrgProjectSupplyOrdersRoute,
    ConsolePOrgProjectSupplyShipmentsRoute:
      ConsolePOrgProjectSupplyShipmentsRoute,
    ConsolePOrgProjectSupplyIndexRoute: ConsolePOrgProjectSupplyIndexRoute,
  };

const ConsolePOrgProjectSupplyRouteRouteWithChildren =
  ConsolePOrgProjectSupplyRouteRoute._addFileChildren(
    ConsolePOrgProjectSupplyRouteRouteChildren,
  );

interface ConsolePOrgProjectTrainingRouteRouteChildren {
  ConsolePOrgProjectTrainingCompareRoute: typeof ConsolePOrgProjectTrainingCompareRoute;
  ConsolePOrgProjectTrainingIndexRoute: typeof ConsolePOrgProjectTrainingIndexRoute;
  ConsolePOrgProjectTrainingJobsJobIdRoute: typeof ConsolePOrgProjectTrainingJobsJobIdRoute;
  ConsolePOrgProjectTrainingResearchSessionNameRoute: typeof ConsolePOrgProjectTrainingResearchSessionNameRoute;
  ConsolePOrgProjectTrainingRunsRunIdRoute: typeof ConsolePOrgProjectTrainingRunsRunIdRoute;
  ConsolePOrgProjectTrainingResearchIndexRoute: typeof ConsolePOrgProjectTrainingResearchIndexRoute;
  ConsolePOrgProjectTrainingRunsIndexRoute: typeof ConsolePOrgProjectTrainingRunsIndexRoute;
}

const ConsolePOrgProjectTrainingRouteRouteChildren: ConsolePOrgProjectTrainingRouteRouteChildren =
  {
    ConsolePOrgProjectTrainingCompareRoute:
      ConsolePOrgProjectTrainingCompareRoute,
    ConsolePOrgProjectTrainingIndexRoute: ConsolePOrgProjectTrainingIndexRoute,
    ConsolePOrgProjectTrainingJobsJobIdRoute:
      ConsolePOrgProjectTrainingJobsJobIdRoute,
    ConsolePOrgProjectTrainingResearchSessionNameRoute:
      ConsolePOrgProjectTrainingResearchSessionNameRoute,
    ConsolePOrgProjectTrainingRunsRunIdRoute:
      ConsolePOrgProjectTrainingRunsRunIdRoute,
    ConsolePOrgProjectTrainingResearchIndexRoute:
      ConsolePOrgProjectTrainingResearchIndexRoute,
    ConsolePOrgProjectTrainingRunsIndexRoute:
      ConsolePOrgProjectTrainingRunsIndexRoute,
  };

const ConsolePOrgProjectTrainingRouteRouteWithChildren =
  ConsolePOrgProjectTrainingRouteRoute._addFileChildren(
    ConsolePOrgProjectTrainingRouteRouteChildren,
  );

interface ConsolePOrgProjectWorkAtlasRouteRouteChildren {
  ConsolePOrgProjectWorkAtlasHomeRoute: typeof ConsolePOrgProjectWorkAtlasHomeRoute;
  ConsolePOrgProjectWorkAtlasOccupationsRoute: typeof ConsolePOrgProjectWorkAtlasOccupationsRoute;
  ConsolePOrgProjectWorkAtlasOpportunitiesRoute: typeof ConsolePOrgProjectWorkAtlasOpportunitiesRoute;
  ConsolePOrgProjectWorkAtlasSkillsRoute: typeof ConsolePOrgProjectWorkAtlasSkillsRoute;
  ConsolePOrgProjectWorkAtlasTasksRoute: typeof ConsolePOrgProjectWorkAtlasTasksRoute;
  ConsolePOrgProjectWorkAtlasIndexRoute: typeof ConsolePOrgProjectWorkAtlasIndexRoute;
}

const ConsolePOrgProjectWorkAtlasRouteRouteChildren: ConsolePOrgProjectWorkAtlasRouteRouteChildren =
  {
    ConsolePOrgProjectWorkAtlasHomeRoute: ConsolePOrgProjectWorkAtlasHomeRoute,
    ConsolePOrgProjectWorkAtlasOccupationsRoute:
      ConsolePOrgProjectWorkAtlasOccupationsRoute,
    ConsolePOrgProjectWorkAtlasOpportunitiesRoute:
      ConsolePOrgProjectWorkAtlasOpportunitiesRoute,
    ConsolePOrgProjectWorkAtlasSkillsRoute:
      ConsolePOrgProjectWorkAtlasSkillsRoute,
    ConsolePOrgProjectWorkAtlasTasksRoute:
      ConsolePOrgProjectWorkAtlasTasksRoute,
    ConsolePOrgProjectWorkAtlasIndexRoute:
      ConsolePOrgProjectWorkAtlasIndexRoute,
  };

const ConsolePOrgProjectWorkAtlasRouteRouteWithChildren =
  ConsolePOrgProjectWorkAtlasRouteRoute._addFileChildren(
    ConsolePOrgProjectWorkAtlasRouteRouteChildren,
  );

interface ConsolePOrgProjectOrdersRouteChildren {
  ConsolePOrgProjectOrdersIndexRoute: typeof ConsolePOrgProjectOrdersIndexRoute;
}

const ConsolePOrgProjectOrdersRouteChildren: ConsolePOrgProjectOrdersRouteChildren =
  {
    ConsolePOrgProjectOrdersIndexRoute: ConsolePOrgProjectOrdersIndexRoute,
  };

const ConsolePOrgProjectOrdersRouteWithChildren =
  ConsolePOrgProjectOrdersRoute._addFileChildren(
    ConsolePOrgProjectOrdersRouteChildren,
  );

interface ConsolePOrgProjectTasksRouteChildren {
  ConsolePOrgProjectTasksTaskIdRoute: typeof ConsolePOrgProjectTasksTaskIdRoute;
  ConsolePOrgProjectTasksIndexRoute: typeof ConsolePOrgProjectTasksIndexRoute;
}

const ConsolePOrgProjectTasksRouteChildren: ConsolePOrgProjectTasksRouteChildren =
  {
    ConsolePOrgProjectTasksTaskIdRoute: ConsolePOrgProjectTasksTaskIdRoute,
    ConsolePOrgProjectTasksIndexRoute: ConsolePOrgProjectTasksIndexRoute,
  };

const ConsolePOrgProjectTasksRouteWithChildren =
  ConsolePOrgProjectTasksRoute._addFileChildren(
    ConsolePOrgProjectTasksRouteChildren,
  );

interface ConsolePOrgProjectRouteChildren {
  ConsolePOrgProjectBuildWorldsRouteRoute: typeof ConsolePOrgProjectBuildWorldsRouteRouteWithChildren;
  ConsolePOrgProjectDeployRouteRoute: typeof ConsolePOrgProjectDeployRouteRouteWithChildren;
  ConsolePOrgProjectLibraryRouteRoute: typeof ConsolePOrgProjectLibraryRouteRouteWithChildren;
  ConsolePOrgProjectReportsRouteRoute: typeof ConsolePOrgProjectReportsRouteRouteWithChildren;
  ConsolePOrgProjectSimulateRouteRoute: typeof ConsolePOrgProjectSimulateRouteRouteWithChildren;
  ConsolePOrgProjectSupplyRouteRoute: typeof ConsolePOrgProjectSupplyRouteRouteWithChildren;
  ConsolePOrgProjectTrainingRouteRoute: typeof ConsolePOrgProjectTrainingRouteRouteWithChildren;
  ConsolePOrgProjectWorkAtlasRouteRoute: typeof ConsolePOrgProjectWorkAtlasRouteRouteWithChildren;
  ConsolePOrgProjectOperationsRoute: typeof ConsolePOrgProjectOperationsRoute;
  ConsolePOrgProjectOrdersRoute: typeof ConsolePOrgProjectOrdersRouteWithChildren;
  ConsolePOrgProjectSettingsRoute: typeof ConsolePOrgProjectSettingsRoute;
  ConsolePOrgProjectTasksRoute: typeof ConsolePOrgProjectTasksRouteWithChildren;
  ConsolePOrgProjectIndexRoute: typeof ConsolePOrgProjectIndexRoute;
  ConsolePOrgProjectLoopBoardRoute: typeof ConsolePOrgProjectLoopBoardRoute;
  ConsolePOrgProjectLoopManagerRoute: typeof ConsolePOrgProjectLoopManagerRoute;
  ConsolePOrgProjectLoopTeamRoute: typeof ConsolePOrgProjectLoopTeamRoute;
  ConsolePOrgProjectRobotsComposeRoute: typeof ConsolePOrgProjectRobotsComposeRoute;
  ConsolePOrgProjectLoopIndexRoute: typeof ConsolePOrgProjectLoopIndexRoute;
  ConsolePOrgProjectRobotsIndexRoute: typeof ConsolePOrgProjectRobotsIndexRoute;
  ConsolePOrgProjectRobotsBodiesBodyRoute: typeof ConsolePOrgProjectRobotsBodiesBodyRoute;
  ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125Route: typeof ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125Route;
}

const ConsolePOrgProjectRouteChildren: ConsolePOrgProjectRouteChildren = {
  ConsolePOrgProjectBuildWorldsRouteRoute:
    ConsolePOrgProjectBuildWorldsRouteRouteWithChildren,
  ConsolePOrgProjectDeployRouteRoute:
    ConsolePOrgProjectDeployRouteRouteWithChildren,
  ConsolePOrgProjectLibraryRouteRoute:
    ConsolePOrgProjectLibraryRouteRouteWithChildren,
  ConsolePOrgProjectReportsRouteRoute:
    ConsolePOrgProjectReportsRouteRouteWithChildren,
  ConsolePOrgProjectSimulateRouteRoute:
    ConsolePOrgProjectSimulateRouteRouteWithChildren,
  ConsolePOrgProjectSupplyRouteRoute:
    ConsolePOrgProjectSupplyRouteRouteWithChildren,
  ConsolePOrgProjectTrainingRouteRoute:
    ConsolePOrgProjectTrainingRouteRouteWithChildren,
  ConsolePOrgProjectWorkAtlasRouteRoute:
    ConsolePOrgProjectWorkAtlasRouteRouteWithChildren,
  ConsolePOrgProjectOperationsRoute: ConsolePOrgProjectOperationsRoute,
  ConsolePOrgProjectOrdersRoute: ConsolePOrgProjectOrdersRouteWithChildren,
  ConsolePOrgProjectSettingsRoute: ConsolePOrgProjectSettingsRoute,
  ConsolePOrgProjectTasksRoute: ConsolePOrgProjectTasksRouteWithChildren,
  ConsolePOrgProjectIndexRoute: ConsolePOrgProjectIndexRoute,
  ConsolePOrgProjectLoopBoardRoute: ConsolePOrgProjectLoopBoardRoute,
  ConsolePOrgProjectLoopManagerRoute: ConsolePOrgProjectLoopManagerRoute,
  ConsolePOrgProjectLoopTeamRoute: ConsolePOrgProjectLoopTeamRoute,
  ConsolePOrgProjectRobotsComposeRoute: ConsolePOrgProjectRobotsComposeRoute,
  ConsolePOrgProjectLoopIndexRoute: ConsolePOrgProjectLoopIndexRoute,
  ConsolePOrgProjectRobotsIndexRoute: ConsolePOrgProjectRobotsIndexRoute,
  ConsolePOrgProjectRobotsBodiesBodyRoute:
    ConsolePOrgProjectRobotsBodiesBodyRoute,
  ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125Route:
    ConsolePOrgProjectLoopAgentAgentIdChar123SessionIdChar125Route,
};

const ConsolePOrgProjectRouteWithChildren =
  ConsolePOrgProjectRoute._addFileChildren(ConsolePOrgProjectRouteChildren);

interface ConsoleRouteChildren {
  ConsoleLabelRouteRoute: typeof ConsoleLabelRouteRouteWithChildren;
  ConsoleOperationsRouteRoute: typeof ConsoleOperationsRouteRouteWithChildren;
  ConsoleProductionRouteRoute: typeof ConsoleProductionRouteRouteWithChildren;
  ConsoleSettingsRouteRoute: typeof ConsoleSettingsRouteRouteWithChildren;
  ConsoleTeleoperatorsRouteRoute: typeof ConsoleTeleoperatorsRouteRouteWithChildren;
  ConsoleSplatRoute: typeof ConsoleSplatRoute;
  ConsoleProjectsRoute: typeof ConsoleProjectsRouteWithChildren;
  ConsoleIndexRoute: typeof ConsoleIndexRoute;
  ConsoleSuperviseSplatRoute: typeof ConsoleSuperviseSplatRoute;
  ConsolePOrgProjectRoute: typeof ConsolePOrgProjectRouteWithChildren;
}

const ConsoleRouteChildren: ConsoleRouteChildren = {
  ConsoleLabelRouteRoute: ConsoleLabelRouteRouteWithChildren,
  ConsoleOperationsRouteRoute: ConsoleOperationsRouteRouteWithChildren,
  ConsoleProductionRouteRoute: ConsoleProductionRouteRouteWithChildren,
  ConsoleSettingsRouteRoute: ConsoleSettingsRouteRouteWithChildren,
  ConsoleTeleoperatorsRouteRoute: ConsoleTeleoperatorsRouteRouteWithChildren,
  ConsoleSplatRoute: ConsoleSplatRoute,
  ConsoleProjectsRoute: ConsoleProjectsRouteWithChildren,
  ConsoleIndexRoute: ConsoleIndexRoute,
  ConsoleSuperviseSplatRoute: ConsoleSuperviseSplatRoute,
  ConsolePOrgProjectRoute: ConsolePOrgProjectRouteWithChildren,
};

const ConsoleRouteWithChildren =
  ConsoleRoute._addFileChildren(ConsoleRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  ConsoleRoute: ConsoleRouteWithChildren,
  HeadsetRoute: HeadsetRoute,
  SignedOutRoute: SignedOutRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
